/* eslint-disable quote-props */
const messages = {
  'en': {
    'Navigation': {
      'framework_manager': 'Bokvalitet Designer',
    },
    'Framework Manager': {
      'title': 'Bokvalitet Designer',
      'Tabs': {
        'Categories': 'Categories',
        'Subcategories': 'Subcategories',
        'Questions': 'Questions',
      },
      'Categories': {
        'title': 'Categories',
        'title_placeholder': 'Enter category title',
        'no_categories': 'No categories found',
        'add_category': 'Add Category',
        'confirm_delete': 'Are you sure you want to delete this category?',
        'cannot_delete_with_subcategories': 'Cannot delete category with subcategories',
        'delete_error': 'Error deleting category',
        'questions_count': 'Questions: {count}',
        'subcategories_count': 'Subcategories: {count}',
      },
      'Subcategories': {
        'title': 'Subcategories',
        'title_placeholder': 'Enter subcategory title',
        'description_placeholder': 'Enter subcategory description',
        'no_subcategories': 'No subcategories found',
        'add_subcategory': 'Add Subcategory',
        'confirm_delete': 'Are you sure you want to delete this subcategory?',
        'cannot_delete_with_questions': 'Cannot delete subcategory with questions',
        'delete_error': 'Error deleting subcategory',
        'questions_count': 'Questions: {count}',
      },
      'Questions': {
        'title': 'Questions',
        'title_placeholder': 'Enter question title',
        'description_placeholder': 'Enter question description',
        'description': 'Description',
        'no_questions': 'No questions found',
        'add_question': 'Add Question',
        'confirm_delete': 'Are you sure you want to delete this question?',
        'delete_error': 'Error deleting question',
        'edit': 'Edit',
        'delete': 'Delete',
        'save': 'Save',
        'cancel': 'Cancel',
        'save_error': 'Error saving question',
        'objective': 'Objective',
        'subjective': 'Subjective',
        'enabled': 'Enabled',
        'disabled': 'Disabled',
        'language_select': 'Language',
        'edit_translations': 'Edit translations',
      },
      'Modals': {
        'cancel': 'Cancel',
        'save': 'Save',
        'create': 'Create',
        'EditCategory': {
          'title': 'Edit Category',
          'title_field': 'Title',
          'title_placeholder': 'Enter category title',
          'color': 'Color',
          'color_placeholder': 'Enter color code (hex)',
          'icon': 'Icon',
          'icon_url_placeholder': 'Enter icon URL',
          'icon_help': 'URL to an image file or icon',
          'description': 'Description',
          'description_placeholder': 'Enter category description',
          'order': 'Order Index',
          'order_placeholder': 'Enter display order (0, 1, 2...)',
          'save_error': 'An error occurred while saving the category.',
        },
        'CreateCategory': {
          'title': 'Create Category',
          'title_field': 'Title',
          'title_placeholder': 'Enter category title',
          'color': 'Color',
          'color_placeholder': 'Enter color code (hex)',
          'icon': 'Icon',
          'icon_url_placeholder': 'Enter icon URL',
          'icon_help': 'URL to an image file or icon',
          'description': 'Description',
          'description_placeholder': 'Enter category description',
          'order': 'Order Index',
          'order_placeholder': 'Enter display order (0, 1, 2...)',
          'create_error': 'An error occurred while creating the category.',
        },
        'EditSubcategory': {
          'title': 'Edit Subcategory',
          'title_field': 'Title',
          'title_placeholder': 'Enter subcategory title',
          'category': 'Category',
          'category_placeholder': 'Select a category',
          'description': 'Description',
          'description_placeholder': 'Enter subcategory description',
          'is_required': 'Required',
          'order': 'Order Index',
          'order_placeholder': 'Enter display order (0, 1, 2...)',
          'select_category_error': 'Please select a category for this subcategory.',
          'save_error': 'An error occurred while saving the subcategory.',
        },
        'CreateSubcategory': {
          'title': 'Create Subcategory',
          'title_field': 'Title',
          'title_placeholder': 'Enter subcategory title',
          'category': 'Category',
          'category_placeholder': 'Select a category',
          'description': 'Description',
          'description_placeholder': 'Enter subcategory description',
          'is_required': 'Required',
          'order': 'Order Index',
          'order_placeholder': 'Enter display order (0, 1, 2...)',
          'select_category_error': 'Please select a category for this subcategory.',
          'create_error': 'An error occurred while creating the subcategory.',
        },
        'EditQuestion': {
          'title': 'Edit Question',
          'title_field': 'Title',
          'title_placeholder': 'Enter question title',
          'description': 'Description',
          'description_placeholder': 'Enter question description',
          'vote_type': 'Vote Type',
          'vote_type_placeholder': 'Select a vote type',
          'is_enabled': 'Enabled',
          'subcategory_associations': 'Subcategory Associations',
          'no_subcategories': 'No subcategories available in this framework.',
          'enabled_in_subcategory': 'Enabled in this subcategory',
          'select_vote_type_error': 'Please select a vote type for this question.',
          'save_error': 'An error occurred while saving the question.',
        },
        'CreateQuestion': {
          'title': 'Create Question',
          'title_field': 'Title',
          'title_placeholder': 'Enter question title',
          'description': 'Description',
          'description_placeholder': 'Enter question description',
          'vote_type': 'Vote Type',
          'vote_type_placeholder': 'Select a vote type',
          'is_enabled': 'Enabled',
          'subcategory_associations': 'Subcategory Associations',
          'filter_by_category': 'Filter subcategories by category',
          'no_subcategories': 'No subcategories available in this framework.',
          'enabled_in_subcategory': 'Enabled in this subcategory',
          'all_categories': 'All categories',
          'select_vote_type_error': 'Please select a vote type for this question.',
          'select_subcategory_error': 'Please select at least one subcategory for this question.',
          'create_error': 'An error occurred while creating the question.',
        },
      },
    },
    'Header': {
      'AdminMenuLabel': 'Admin',
      'Button01': 'About LINK Architecture',
      'Button02': 'About LINK Compass',
      'Button03': 'Projects',
      'Button04': 'Log in',
      'Button04_alt': 'Log out',
      'Button05': 'Change password',
      'Button06': 'Action designer',
      'Button07': 'CMS',
      'Button08': 'Organizations',
      'Button09': 'Users',
      'Button10': 'Support',
      'Button11': 'Bokvalitet Designer',
      'Button12': 'Subscription',
      'Button13': 'Frameworks',
    },
    'Shared': {
      'compass': 'Compass',
      'project': 'Project',
      'projects': 'Projects',
      'enabled': 'Enabled',
      'disabled': 'Disabled',
      'folder': 'Folder',
      'folders': 'Folders',
      'category': 'Category',
      'categories': 'Categories',
      'subcategory': 'Subcategory',
      'subcategories': 'Subcategories',
      'standard_action': 'Standard action',
      'standard_actions': 'Standard actions',
      'action': 'Action',
      'actions': 'Actions',
      'ambition': 'Ambition',
      'vision': 'Vision',
      'effect': 'Effect',
      'chooseFramework': 'Choose framework',
      'recommended': 'Recommended',
      'collected': 'Collected',
      'collections': 'Collections',
      'all': 'All',
      'library': 'Library',
      'custom': 'DIY',
      'edit': 'Edit',
      'cancel': 'Cancel',
      'close': 'Close',
      'try again': 'Try again',
      'save': 'Save',
      'saving': 'Saving',
      'saved': 'Saved',
      'add': 'Add',
      'delete': 'Delete',
      'copy': 'Copy',
      'new action': 'New action',
      'outside': 'Outside',
      'no_goals': 'No goals',
      'goal_label': 'Goal',
      'no_actions': 'No actions',
      'create': 'Create',
      'loading': 'Loading',
      'rating': 'Rating',
      'ratings': 'Ratings',
      'choose': 'Choose',
      'title': 'Title',
      'description': 'Description',
      'icon': 'Icon',
      'color': 'Color',
      'controls': 'Controls',
      'search': 'Search',
      'warning': 'Warning',
      'export': 'Export',
      'next': 'Next',
      'previous': 'Previous',
      'end_workshop': 'End workshop',
      'expand_all': 'Expand all',
      'collapse_all': 'Collapse all',
      'objective_short': 'Obj.',
      'subjective_short': 'Subj.',
      'menu': 'Menu',
    },
    'Unauthorized': {
      'title': 'Access Denied',
      'message': 'You do not have the necessary permissions to access this page.',
      'explanation': 'This page requires special administrator privileges. If you believe you should have access to this page, please contact your system administrator.',
      'attempted_access': 'Attempted access to:',
      'go_home': 'Go to homepage',
      'go_projects': 'My projects',
    },
    'Organizations': {
      'All organizations view': {
        'Organization_card_contact_person': 'Contact person',
        'Organization_card_contact_phone': 'Phone number',
        'Organization_card_contact_email': 'Email address',
        'Section_admin_users_title': 'Admin users',
        'Organization_card_parent': 'Parent organization',
        'Organization_hierarchy_title': 'Organization Hierarchy',
        'Switch_to_list': 'Switch to list view',
        'Switch_to_hierarchy': 'Switch to hierarchy view',
        'Organization_hierarchy': 'Organization Structure',
      },
      'Popups': {
        'Create_title': 'New Organization',
        'Edit_title': 'Edit Organization',
        'Input_org_name_validation': 'Organization name is required.',
        'Section_basic_info_title': 'Basic Information',
        'Section_main_contact_title': 'Main Contact',
        'Section_users_title': 'Users',
        'Section_frameworks_title': 'Frameworks',
        'Section_workshop_steps_title': 'Workshop Steps',
        'Section_basic_info_description': 'Add basic information about the organization',
        'Section_users_description': 'Invite one or more people to become administrators of the new organization',
        'Section_frameworks_description': 'Choose which frameworks should be available for this organization',
        'Section_workshop_steps_description': 'Choose which workshop steps should be available for this organization and add them to the standard workshop flow (workshop steps that are part of the standard workshop flow must be selected)',
        'Select_parent_organization': 'Select an existing organization as the parent organization',
        'No_parent_organization': 'None (this organization is top level)',
        'Organization_hierarchy': 'Organization Hierarchy',
        'Organization_no_parent': 'No parent organization',
        'Child_organizations': 'Child organizations',
        'Input_main_contact_name_validation': 'Navn er påkrevd.',
        'Input_main_contact_email_validation': 'Ugyldig e-postformat.',
        'Input_main_contact_phone_validation': 'Telefonnummer er påkrevd.',
        'Section_org_admins_description': 'Inviter en eller flere personer til å bli admin i den nye organisasjonen',
        'Input_org_admins_validation': 'Navn og e-post er påkrevd for alle administratorer.',
        'Form_action_create': 'Opprett organisasjon',
        'Form_action_next': '@:Shared.next',
        'Form_action_previous': '@:Shared.previous',
        'Button_edit': '@:Shared.edit',
        'Button_cancel': '@:Shared.cancel',
        'Button_save': '@:Shared.save',
        'Create_status_success': 'Organisasjonen ble opprettet',
        'Create_status_error': 'Kunne ikke opprette organisasjonen',
        'Create_status_loading': 'Oppretter organisasjon...',
        'Create_status_all_fields_required': 'Alle felt er påkrevd',
        'Update_status_success': 'Organisasjonen ble oppdatert',
        'Update_status_error': 'Oppdatering av organisasjonen feilet',
        'Update_status_loading': 'Oppdaterer organisasjon...',
        'Update_status_no_change': 'Ingen endringer ble gjort',
        'IsDefaultFramework': 'Standard rammeværk',
        'MakeDefaultFramework': 'Gjør til standard',
        'Validation_error_no_frameworks_selected': 'Du må velge minst et rammeværk.',
        'Validation_error_no_default_framework_selected': 'Giv organisasjonen tilgang til rammeværket for å kunne bruke det som standard.',
        'Section_default_workshop_flow_title': 'Standard workshop-flyt',
        'Section_default_workshop_flow_description': 'Customiser standard workshop-flyten for denne organisasjonen',
        'Section_available_workshop_steps_title': 'Tilgjengelige workshop-steg',
        'Section_available_workshop_steps_description': 'Velg hvilke workshop-steg som skal være tilgjengelige for denne organisasjonen og legg til dem i standard workshop-flyten (workshop-steg som er en del av standard workshop-flyten må være valgt)',
        'Toggle_users_can_edit_default_workshop_steps_label': 'Tillat brukere å redigere standard workshop-steg',
        'Toggle_all_workshop_steps_enabled_label': 'Aktiver alle',
        'Confirm_unsaved_changes': 'Du har gjort endringer som ikke er lagret. Er du sikker på at du vil forlate denne siden?',
        'Warning_fix_errors': 'Du må fikse feilene før du kan lagre',
        'No_admin_user_validation': 'Du må ha minst en admin-bruker i organisasjonen',
        'Confirm_inactive_admin': 'Siden brukeren ennå ikke er aktivert, vil dette fjerne brukeren og gjøre invitasjonen ugyldig?',
        'Message_cant_delete_active_user': 'På dette tidspunktet kan du ikke slette aktive brukere her. Du kan slette brukere i din egen organisasjon under brukeradministrasjonen.',
      },
      'Archive': {
        'Delete_title': 'Delete organization',
        'Delete_confirm_intro': 'You are about to archive {name}.',
        'Delete_warning_users': 'All users in this organization will be permanently deleted.',
        'Delete_warning_projects': 'All projects will be detached from users.',
        'Delete_warning_archived': 'The organization will be marked as archived.',
        'Delete_confirm_instruction': 'Type {confirmText} to confirm.',
        'Delete_confirm_label': 'Confirmation text',
        'Delete_confirm_validation': 'Please type "I want to delete" exactly.',
        'Delete_button': 'Delete organization',
        'Restore_title': 'Un-delete organization',
        'Restore_intro': 'To un-delete {name}, create the first org-admin below.',
        'Restore_description': 'This runs as one action: create admin user, then unarchive the organization and re-assign archived projects to that admin.',
        'Restore_admin_name_label': 'First org-admin name',
        'Restore_admin_email_label': 'First org-admin email',
        'Restore_validation': 'Please enter a valid name and email.',
        'Restore_button': 'Un-delete organization',
        'Archived_badge': 'Archived',
        'Restore_button_short': 'Un-delete',
        'Delete_button_short': 'Delete',
        'Delete_status_loading': 'Deleting organization...',
        'Delete_status_success': 'Organization archived.',
        'Delete_status_error_children': 'Organization has child organizations. Remove or reassign children first.',
        'Delete_status_error_forbidden': 'You do not have permission to delete this organization.',
        'Delete_status_error_not_found': 'Organization not found.',
        'Delete_status_error_generic': 'Failed to delete organization.',
        'Restore_status_loading': 'Restoring organization...',
        'Restore_status_success': 'Organization restored.',
        'Restore_status_error_conflict': 'An account with this email already exists.',
        'Restore_status_error_forbidden': 'You do not have permission to restore this organization.',
        'Restore_status_error_generic': 'Failed to restore organization.',
        'Cancel': '@:Shared.cancel',
      },
    },
    'UserAdmin': {
      'User list': {
        'Title': 'Brukere',
        'Button_create_user_label': 'Opprett ny bruker i organisasjonen din',
      },
      'Edit user popup': {
        'Title': 'Rediger bruker',
        'Section_user_name_title': 'Brukernavn',
        'Section_contact_info_title': 'Kontaktinformasjon',
        'Input_contact_email_placeholder': 'E-post',
        'Input_contact_phone_placeholder': 'Telefon',
        'Button_delete': 'Slett',
        'Button_edit': 'Rediger',
        'Button_cancel': 'Avbryt',
        'Button_save': 'Lagre',
        'Button_make_admin': 'Gjør til admin',
        'Button_revoke_admin': 'Fjern admin',
        'Status_success': 'Brukeren ble oppdatert',
        'Status_error': 'Oppdatering av brukeren feilet',
        'Status_loading': 'Oppdaterer bruker...',
        'Status_delete_success': 'Brukeren ble slettet',
        'Status_delete_error': 'Sletting av brukeren feilet',
        'Status_no_change': 'Ingen endringer ble gjort',
        'Confirm_delete_user': 'Er du sikker på at du vil slette denne brukeren?',
        'Confirm_make_admin': 'Er du sikker på at du vil gjøre denne brukeren til admin?',
        'Confirm_revoke_admin': 'Er du sikker på at du vil fjerne admin-rettigheter fra denne brukeren?',
        'Confirm_revoke_own_admin': 'Er du sikker på at du vil fjerne dine egne admin-rettigheter?',
      },
      'Create user popup': {
        'Title': 'Opprett ny bruker',
        'Section_user_name_title': 'Brukernavn',
        'Section_contact_info_title': 'Kontaktinformasjon',
        'Input_contact_email_placeholder': 'E-post',
        'Input_contact_phone_placeholder': 'Telefon',
        'Form_action_create': 'Opprett bruker',
        'Status_success': 'Brukeren ble opprettet',
        'Status_error': 'Kunne ikke opprette brukeren',
        'Status_loading': 'Oppretter bruker...',
        'Status_all_fields_required': 'Alle felt er påkrevd',
        'Input_user_name_validation': 'Brukernavn er påkrevd.',
        'Input_contact_email_validation': 'Ugyldig e-postformat.',
        'Input_contact_phone_validation': 'Telefonnummer er påkrevd.',
      },
    },
    'Collections': {
      'Add collection': 'Legg til samling',
      'New collection': 'Ny samling',
      'No collections available': 'Ingen samlinger tilgjengelige',
    },
    'Action designer': {
      'Tabs': {
        'All actions': 'Alle tiltak',
        'Collections': 'Samlinger',
      },
      'Framework': {
        'Select framework': 'Velg rammeverk',
      },
      'Actions': {
        'button_add_action': 'Legg til tiltak',
        'delete_action_warning': 'Er du sikker? Når du sletter en standard handling, vil den ikke lenger være synlig i biblioteket, og den vil bli fjernet fra samlinger. Kompasser hvor handlingen ble lagt til vil ikke endres.',
        'no_collections_message': 'ikke i noen samlinger',
        'missing_sub_category_message': 'Mangler fokusområde',
      },
      'New collection popup': {
        'Title': 'Ny samling',
        'Label01': 'Samlingens navn',
        'Label02': 'Velg rammeverk',
        'Button01': 'Avbryt',
        'Button02': 'Lagre',
        'Created message': 'Ny samling opprettet',
        'Status_loading': 'Oppretter samling...',
        'Status_success': 'Samlingen ble opprettet',
        'Status_error': 'Kunne ikke opprette samlingen',
      },
      'Collection': {
        'Button01': 'Lag en kopi',
        'Button02': 'Slett',
        'Button01_tooltip': 'Lag en kopi av en samling.',
        'Button02_tooltip': 'Slett samling, for alle brugere.',
        'isEnabled': 'Samlingen er aktivert',
        'isNotEnabled': 'Samlingen er i utkastmodus',
        'noActions': 'Ingen handlinger i denne kategorien',
        'DeleteConfirm': 'Er du sikker på at du vil slette denne samlingen?',
      },
      'Manage collection access popup': {
        'title': 'Administrer samlingstilgang',
        'Section_visibility_description': 'Velg hvem som har lov til å bruke denne samlingen',
        'Select_visibility_placeholder': 'Velg synlighet',
        'Section_organization_description': 'Velg i hvilke land samlingen er synlig. Landet er satt når du oppretter et nytt kompass.',
        'Section_organizations_description': 'Velg hvilke organisasjoner som har tilgang',
        'Select_visibility_option_private_label': 'Kun meg',
        'Select_visibility_option_organization_label': 'Alle i organisasjonen min',
        'Select_visibility_option_organizations_label': 'Valgte organisasjoner',
        'Select_visibility_option_public_label': 'Alle kan bruke',
        'Update successful': 'Oppdatering vellykket',
        'Update failed': 'Kunne ikke oppdatere',
      },
      'Copy collection popup': {
        'Title': 'Kopier samling',
        'Manchet': 'En ny samling med de samme handlingene vil bli opprettet.',
        'SuccessMessage': 'Samlingen ble kopiert',
        'ErrorMessage': 'Kunne ikke kopiere samlingen',
        'Button01': '@:Shared.cancel',
        'Button02': '@:Shared.copy',
        'Button03': 'Gå til den nye samlingen',
        'Button04': 'Prøv igjen',
      },
    },
    'Cms': {
      'Shared': {
        'MessageNoTranslation': 'Ingen oversætting',
        'MessageNotEditable': 'Kan ikke redigeres her',
      },
      'Main view': {
        'Tab01': 'Standard tiltak',
        'Tab02': '@:Shared.category & @:Shared.subcategory',
        'Tab03': 'Tekster',
        'Tab04': 'Rapport tekstbidder',
        'Tab05': 'Frameworks',
      },
      'Standard actions view': {
        'Button01': 'Legg til standard tiltak',
        'Button03': 'Hent flere tiltak',
      },
      'Categories view': {
        'Button01': '@:Shared.edit @:Shared.category',
        'Button02': '@:Shared.edit @:Shared.subcategory',
        'MessageNoTranslation': 'No translation',
      },
      'Category view': {
        'Button01': 'Rediger tema',
        'Button02': 'Slett undertema',
        'Button03': 'Rediger undertema',
      },
      'Edit category popup': {
        'Title': 'Rediger @:Shared.category',
        'Label01': '@:Shared.category titel',
        'Label01A': 'Reference tekst',
        'Label02': '@:Shared.category beskrivelse',
        'Label03': 'Farve hex kode',
        'Label03A': 'Farve eksempel',
        'Button01': '@:Shared.cancel',
        'Button02': 'Slett @:Shared:category',
        'Button03': '@:Shared.save',
        'Button03_loading': '@:Shared.saving',
      },
      'Edit subcategory popup': {
        'Title': 'Rediger @:Shared.subcategory',
        'Label01': '@:Shared.subcategory titel',
        'Label01A': 'Reference tekst',
        'Label02': '@:Shared.subcategory beskrivelse',
        'Label03': 'Farve hex kode',
        'Label03A': 'Farve eksempel',
        'Button01': '@:Shared.cancel',
        'Button02': 'Slett @:Shared.subcategory',
        'Button03': '@:Shared.save',
        'Button03_loading': '@:Shared.saving',
        'Button03_saved': 'Lukk',
      },
      'Edit standard action popup': {
        'Title': 'Rediger @:Shared.standard_action',
        'Label01': '@:Shared.description',
        'Label01A': 'Reference tekst',
        'Label02': '@:Shared.ratings',
        'Reference info': 'Referanseteksten er bare her for å gjøre oversettelsen enklere',
        'Button01': '@:Shared.cancel',
        'Button02': 'Slett @:Shared.action',
        'Button03': '@:Shared.save',
        'Button03_loading': '@:Shared.saving',
        'Button03_saved': 'Lukk',
      },
    },
    'Frameworks': {
      'LINK Bærekraftstemaer': 'LINK Bærekraftstemaer',
      'Impact Architecture': 'Impact Architecture',
      'FNs bærekraftsmål': 'FNs bærekraftsmål',
      'title': 'Frameworks',
      'subtitle': 'Manage and customize sustainability assessment frameworks',
      'create_new': 'Create New Framework',
      'edit': 'Edit',
      'status_enabled': 'Enabled',
      'status_disabled': 'Disabled',
      'categories': 'Categories',
      'filter_by_country': 'Filter by country',
      'filter_all_countries': 'All countries',
    },
    'Framework Designer': {
      'title': 'Framework Designer',
      'framework_details': 'Framework Details',
      'framework_name': 'Framework Name',
      'framework_name_placeholder': 'Enter framework name',
      'max_value': 'Maximum Value',
      'steps': 'Steps',
      'view_mode': 'View Mode',
      'enabled': 'Framework Enabled',
      'categories': 'Categories',
      'add_category': 'Add Category',
      'edit_category': 'Edit Category',
      'layer_configuration': 'Layer Configuration',
      'layer_label': 'Layer Label',
      'data_source': 'Data Source',
      'opacity': 'Opacity',
      'round_to_step': 'Round to Step',
      'add_layer': 'Add Layer',
      'preview': 'Preview',
      'preview_not_available': 'Add categories and configure layers to see preview',
      'save': 'Save Framework',
      'country_label': 'Available in country',
      'country_all': 'All countries',
      'save_success': 'Framework saved successfully',
      'save_error': 'Error saving framework',
      'layer_1': 'Layer 1',
      'layer_2': 'Layer 2',
      'layered': 'Layered',
      'stacked': 'Stacked',
      'user_ratings': 'User Ratings',
      'action_ratings': 'Action Ratings',
      'objective_ratings': 'Objective Ratings',
      'subjective_ratings': 'Subjective Ratings',
      'back': 'Back',
      'settings': 'Settings',
      'workshop_steps': 'Workshop Steps',
      'available_workshop_steps': 'Available Workshop Steps',
      'default_workshop_flow': 'Default Workshop Flow',
      'add_subcategory': 'Add Subcategory',
      'confirm_delete_subcategory': 'Are you sure you want to delete this subcategory?',
      'subcategory_deleted': 'Subcategory deleted successfully',
      'delete_error': 'Error deleting subcategory',
    },
    'Goal designer': {
      'Add goal collection': 'Add goal collection',
      'EditGoalSubCategory': 'Edit Goal',
      'Tabs': {
        'All collections': 'All collections',
      },
      'Collection': {
        'Button01': 'Create a copy',
        'Button02': 'Delete',
        'Button01_tooltip': 'Create a copy of a collection.',
        'Button02_tooltip': 'Delete collection, for all users.',
        'enabled goals': 'enabled goals',
        'isEnabled': 'Collection is enabled',
        'isNotEnabled': 'Collection is in draft mode',
        'DeleteConfirm': 'Are you sure you want to delete this collection?',
      },
      'New goal collection popup': {
        'Title': 'New collection',
        'Label01': 'Collection name',
        'Label02': 'Collection framework',
        'Button01': 'Cancel',
        'Button02': 'Save',
        'Status_loading': 'Creating collection...',
        'Status_success': 'Collection was created',
        'Status_error': 'Could not create collection',
      },
    },
    'Workshop': {
      'Goal collections panel': {
        'switch_from_no_collection_message': 'This will apply a goal collection to your project. If you\'ve activated, deactivated focus areas and added goal descriptions and ratings, this will be overwritten. Do you want to continue?',
        'switch_between_collections_message': 'Switching to this goal collection will overwrite all existing goal ratings and descriptions. Do you want to continue?',
      },
      'ActionAdded': {
        'SubcategoryActivated': 'Focus area activated',
        'SubcategoryActivatedMessage': 'The focus area "{name}" was activated to accommodate the added action.',
        'MultipleSubcategoriesActivatedTitle': '{count} focus areas activated',
        'MultipleSubcategoriesActivated': '{count} focus areas were activated to accommodate the added actions: {names}',
        'MultipleSubcategoriesActivatedWithMore': '{count} focus areas were activated to accommodate the added actions: {names} and {count} more.',
      },
    },
    'Projects': {
      'Project view': {
        'Button08': 'Export to PDF',
        'Button08_description': 'Download the latest report as a PDF',
      },
      'ExportPdf': {
        'Title': 'Export to PDF',
        'SelectReport': 'Select report',
        'OpenReport': 'Open report',
        'Download': 'Download PDF',
        'Cancel': 'Cancel',
        'NoReports': 'This project has no report yet. Create one from the default template to export.',
        'CreateReport': 'Create report',
        'Creating': 'Creating report...',
        'Generating': 'Generating PDF...',
        'Error': 'Could not generate the PDF. Please try again.',
        'CreateError': 'Could not create the report.',
      },
    },
    'Report': {
      'Toolbar': {
        'Button09': 'Save as template',
        'Button10': 'Load template',
      },
      'Templates': {
        'Title': 'Choose template',
        'SaveTitle': 'Save as template',
        'Name': 'Template name',
        'Visibility': 'Who can use the template',
        'VisibilityPrivate': 'Only me',
        'VisibilityOrganization': 'My organization',
        'VisibilityPublic': 'Everyone',
        'Default': 'Default report',
        'ReplaceWarning': 'Loading a template replaces the content of the report.',
        'Use': 'Use',
        'Rename': 'Rename',
        'Delete': 'Delete',
        'ConfirmDelete': 'Are you sure?',
        'Save': 'Save',
        'Cancel': 'Cancel',
        'Empty': 'No templates available',
        'Saved': 'Template saved',
        'Error': 'Something went wrong. Please try again.',
      },
    },
  },
  'no_NO': {
    'Bokvalitet': {
      'RoseChartHeadline': 'Bokvalitetsrosen',
    },
    'Shared': {
      'compass': 'Kompass',
      'project': 'Project',
      'projects': 'Prosjekter',
      'enabled': 'Aktivert',
      'disabled': 'Deaktivert',
      'folder': 'Folder',
      'folders': 'Folders',
      'category': 'Category',
      'categories': 'Kategorier',
      'subcategory': 'Underkategori',
      'subcategories': 'Underkategorier',
      'standard_action': 'Standard action',
      'standard_actions': 'Standard actions',
      'action': 'Action',
      'actions': 'Handlinger',
      'ambition': 'Ambition',
      'vision': 'Vision',
      'effect': 'Effect',
      'chooseFramework': 'Choose framework',
      'recommended': 'Recommended',
      'collected': 'Collected',
      'collections': 'Collections',
      'all': 'All',
      'library': 'Library',
      'custom': 'DIY',
      'edit': 'Rediger',
      'cancel': 'Avbryt',
      'close': 'Lukk',
      'try again': 'Prøv igjen',
      'save': 'Lagre',
      'saving': 'Laster',
      'saved': 'Lagra',
      'add': 'Legg til',
      'delete': 'Slett',
      'copy': 'Kopier',
      'new action': 'Ny handling',
      'outside': 'Utenfor',
      'no_goals': 'Ingen mål',
      'no_actions': 'Ingen handlinger',
      'create': 'Opprett',
      'loading': 'Laster',
      'rating': 'Vurdering',
      'ratings': 'Vurderinger',
      'choose': 'Velg',
      'title': 'Tittel',
      'description': 'Beskrivelse',
      'icon': 'Ikon',
      'color': 'Farge',
      'controls': 'Kontroller',
      'search': 'Søk',
      'warning': 'Advarsel',
      'export': 'Eksporter',
      'next': 'Neste',
      'previous': 'Forrige',
      'end_workshop': 'Avslutt workshop',
      'expand_all': 'Utvid alle',
      'collapse_all': 'Lukk alle',
      'yes/no': 'Ja/Nei',
      'grade': 'Slett ikke -> I svært høy grad',
      'percent': 'Prosent',
      'text': 'Tekst',
      'user': 'Bruker',
      'users': 'Brukere',
      'email': 'E-post',
      'name': 'Navn',
      'phone': 'Telefon',
      'role': 'Rolle',
      'role_admin': 'Administrator',
      'role_user': 'Bruker',
      'role_guest': 'Gjest',
      'organization_name': 'Organisasjon',
      'organization_address': 'Adresse',
      'pending_invitation': 'Venter på invitasjon',
      'admin': 'Administrator',
      'super_admin': 'Superadministrator',
      'active': 'Aktiv',
      'goals': 'mål',
      'goal_label': 'Målsetting ',
      'warning_fix_errors': 'Vennligst rette feilene før du går videre.',
      'Uncategorized': 'Ukategorisert',
      'objective_short': 'Obj.',
      'subjective_short': 'Subj.',
      'obligatory_short': 'Oblig.',
      'custom_short': 'Egen',
      'menu': 'Meny',
      'changes_saved': 'Ændringer er gemt',
    },
    'Unauthorized': {
      'title': 'Adgang nægtet',
      'message': 'Du har ikke de nødvendige rettigheder til at tilgå denne side.',
      'explanation': 'Denne side kræver særlige administratorrettigheder. Hvis du mener, du bør have adgang til denne side, bedes du kontakte din systemadministrator.',
      'attempted_access': 'Forsøkt adgang til:',
      'go_home': 'Gå til forsiden',
      'go_projects': 'Mine projekter',
    },
    'Navigation': {
      'framework_manager': 'Bokvalitet Designer',
    },
    'Framework Manager': {
      'title': 'Bokvalitet Designer',
      'Tabs': {
        'Categories': 'Kategorier',
        'Subcategories': 'Kriterier',
        'Questions': 'Spørsmål',
      },
      'Categories': {
        'title': 'Kategorier',
        'title_placeholder': 'Skriv inn kategoritittel',
        'no_categories': 'Ingen kategorier funnet',
        'add_category': 'Legg til kategori',
        'confirm_delete': 'Er du sikker på at du vil slette denne kategorien?',
        'cannot_delete_with_subcategories': 'Kan ikke slette kategori med underkategorier',
        'delete_error': 'Feil ved sletting av kategori',
        'questions_count': 'Spørsmål: {count}',
        'subcategories': 'Kriterier',
        'subcategories_count': 'Kriterier: {count}',
      },
      'Subcategories': {
        'title': 'Underkategorier',
        'title_placeholder': 'Skriv inn underkategoritittel',
        'description_placeholder': 'Skriv inn underkategoribeskrivelse',
        'no_subcategories': 'Ingen underkategorier funnet',
        'add_subcategory': 'Legg til underkategori',
        'confirm_delete': 'Er du sikker på at du vil slette denne underkategorien?',
        'cannot_delete_with_questions': 'Kan ikke slette underkategori med spørsmål',
        'delete_error': 'Feil ved sletting av underkategori',
        'questions_count': 'Spørsmål: {count}',
        'required': 'Påkrevd',
      },
      'Questions': {
        'title': 'Spørsmål',
        'title_placeholder': 'Skriv inn spørsmålstittel',
        'description_placeholder': 'Skriv inn spørsmålsbeskrivelse',
        'description': 'Beskrivelse',
        'no_questions': 'Ingen spørsmål funnet',
        'add_question': 'Legg til spørsmål',
        'confirm_delete': 'Er du sikker på at du vil slette dette spørsmålet?',
        'delete_error': 'Feil ved sletting av spørsmål',
        'edit': 'Rediger',
        'delete': 'Slett',
        'save': 'Lagre',
        'cancel': 'Avbryt',
        'save_error': 'Feil ved lagring av spørsmål',
        'objective': 'Objektiv',
        'subjective': 'Subjektiv',
        'enabled': 'Aktivert',
        'disabled': 'Deaktivert',
        'language_select': 'Språk',
        'edit_translations': 'Rediger oversettelser',
      },
      'Modals': {
        'cancel': 'Avbryt',
        'save': 'Lagre',
        'create': 'Opprett',
        'EditCategory': {
          'title': 'Rediger kategori',
          'title_field': 'Tittel',
          'title_placeholder': 'Skriv inn kategoritittel',
          'color': 'Farge',
          'color_placeholder': 'Skriv inn fargekode (hex)',
          'icon': 'Ikon',
          'icon_url_placeholder': 'Skriv inn ikon-URL',
          'icon_help': 'URL til en bildefil eller ikon',
          'description': 'Beskrivelse',
          'description_placeholder': 'Skriv inn kategoribeskrivelse',
          'order': 'Rekkefølge',
          'order_placeholder': 'Skriv inn visningsrekkefølge (0, 1, 2...)',
          'save_error': 'Det oppstod en feil under lagring av kategorien.',
        },
        'CreateCategory': {
          'title': 'Opprett kategori',
          'title_field': 'Tittel',
          'title_placeholder': 'Skriv inn kategoritittel',
          'color': 'Farge',
          'color_placeholder': 'Skriv inn fargekode (hex)',
          'icon': 'Ikon',
          'icon_url_placeholder': 'Skriv inn ikon-URL',
          'icon_help': 'URL til en bildefil eller ikon',
          'description': 'Beskrivelse',
          'description_placeholder': 'Skriv inn kategoribeskrivelse',
          'order': 'Rekkefølge',
          'order_placeholder': 'Skriv inn visningsrekkefølge (0, 1, 2...)',
          'create_error': 'Det oppstod en feil under opprettelse av kategorien.',
        },
        'EditSubcategory': {
          'title': 'Rediger underkategori',
          'title_field': 'Tittel',
          'title_placeholder': 'Skriv inn underkategoritittel',
          'category': 'Kategori',
          'category_placeholder': 'Velg en kategori',
          'description': 'Beskrivelse',
          'description_placeholder': 'Skriv inn underkategoribeskrivelse',
          'is_required': 'Påkrevd',
          'order': 'Plassering',
          'order_placeholder': 'Skriv inn visningsrekkefølge (0, 1, 2...)',
          'select_category_error': 'Vennligst velg en kategori for denne underkategorien.',
          'save_error': 'Det oppstod en feil under lagring av underkategorien.',
        },
        'CreateSubcategory': {
          'title': 'Opprett underkategori',
          'title_field': 'Tittel',
          'title_placeholder': 'Skriv inn underkategoritittel',
          'category': 'Kategori',
          'category_placeholder': 'Velg en kategori',
          'description': 'Beskrivelse',
          'description_placeholder': 'Skriv inn underkategoribeskrivelse',
          'is_required': 'Påkrevd',
          'order': 'Rekkefølge',
          'order_placeholder': 'Skriv inn visningsrekkefølge (0, 1, 2...)',
          'select_category_error': 'Vennligst velg en kategori for denne underkategorien.',
          'create_error': 'Det oppstod en feil under opprettelse av underkategorien.',
        },
        'EditQuestion': {
          'title': 'Rediger spørsmål',
          'title_field': 'Tittel',
          'title_placeholder': 'Skriv inn spørsmålstittel',
          'description': 'Beskrivelse',
          'description_placeholder': 'Skriv inn spørsmålsbeskrivelse',
          'vote_type': 'Avstemmingstype',
          'vote_type_placeholder': 'Velg en avstemmingstype',
          'is_enabled': 'Aktivert',
          'subcategory_associations': 'Underkategori-tilknytninger',
          'no_subcategories': 'Ingen underkategorier tilgjengelig i dette rammeverket.',
          'enabled_in_subcategory': 'Aktivert i denne underkategorien',
          'select_vote_type_error': 'Vennligst velg en avstemmingstype for dette spørsmålet.',
          'save_error': 'Det oppstod en feil under lagring av spørsmålet.',
        },
        'CreateQuestion': {
          'title': 'Opprett spørsmål',
          'title_field': 'Tittel',
          'title_placeholder': 'Skriv inn spørsmålstittel',
          'description': 'Beskrivelse',
          'description_placeholder': 'Skriv inn spørsmålsbeskrivelse',
          'vote_type': 'Avstemmingstype',
          'vote_type_placeholder': 'Velg en avstemmingstype',
          'is_enabled': 'Aktivert',
          'subcategory_associations': 'Underkategori-tilknytninger',
          'filter_by_category': 'Filtrer underkategorier etter kategori',
          'no_subcategories': 'Ingen underkategorier tilgjengelig i dette rammeverket.',
          'enabled_in_subcategory': 'Aktivert i denne underkategorien',
          'all_categories': 'Alle kategorier',
          'select_vote_type_error': 'Vennligst velg en avstemmingstype for dette spørsmålet.',
          'select_subcategory_error': 'Vennligst velg minst én underkategori for dette spørsmålet.',
          'create_error': 'Det oppstod en feil under opprettelse av spørsmålet.',
        },
      },
    },
    'Header': {
      'AdminMenuLabel': 'Admin',
      'Button01': 'Om LINK Arkitektur',
      'Button02': 'Om LINK Kompass',
      'Button03': 'Prosjekter',
      'Button04': 'Logg inn',
      'Button04_alt': 'Logg ut',
      'Button05': 'Bytt passord',
      'Button06': 'Tiltaks designer',
      'Button07': 'Cms',
      'Button08': 'Organisasjoner',
      'Button09': 'Brukere',
      'Button10': 'Support',
      'Button11': 'Bokvalitet Designer',
      'Button12': 'Abonnement',
      'Button13': 'Rammeverk',
      'Button14': 'Målsamlinger',
    },
    'Projects': {
      'Shared': {
        'project_title': 'Prosjekttittel',
        'project_number': 'Prosjektnummer',
        'project_description': 'Prosjektbeskrivelse',
        'project_goals': 'Prosjektmålsettinger',
        'project_folder': 'Prosjektmappe',
      },
      'Project list view': {
        'Title': 'Mine prosjekter',
        'Button01': 'Nytt prosjekt',
        'MessageNoProjects': 'Ingen prosjekter. Legg til et nytt prosjekt.',
        'SharedWithMe': 'Delt med meg',
      },
      'Project view': {
        'Button01': 'Workshop',
        'Button01_description': 'Start en workshop – her kan du samle inn, tilføye og redigere prosjektmålsettinger og tiltak.',
        'Button02': 'Rediger prosjekt',
        'Button02_description': 'Redigere tittel og beskrivelse av prosjekt.',
        'Button03': 'Utforsk',
        'Button03_description': 'Start en utforsk-økt – du kan det samme som i en workshop, men resultatene lagres ikke.',
        'Button04': 'Del',
        'Button04_description': 'Del projekt med en kollega - brugeren får samme rettigheder til at redigere projektet som dig.',
        'Button05': 'Kopier',
        'Button05_description': 'Lav en kopi af prosjekt',
        'Button06': 'Online rapport',
        'Button06_description': 'Lag en online rapport',
        'Button07': 'Eksporter',
        'Button07_description': 'Eksporter prosjektdata til forskjellige formater',
        'Button08': 'Eksporter til PDF',
        'Button08_description': 'Last ned den nyeste rapporten som PDF',
        'Tab01': 'Prosjektinformasjon',
        'Tab02': 'Tema og tiltak',
        'SectionTitle01': '@:Projects.Shared.project_description',
        'SectionTitle02': '@:Projects.Shared.project_goals',
        'MessageNoGoals': '@:Shared.no_goals',
        'DeleteProjectConfirm': 'Er du sikker på at du vil slette dette prosjektet og alle dets handlinger og mål?',
        'ProjectOwner': 'Prosjekteier',
        'ProjectCountry': 'Prosjektland',
        'MessageNoCountry': 'Ingen land valgt',
      },
      'Edit project popup': {
        'Title': 'Rediger prosjekt',
        'Label01': '@:Projects.Shared.project_title',
        'Label02': '@:Projects.Shared.project_description',
        'Label03': '@:Projects.Shared.project_number',
        'Button01': '@:Shared.cancel',
        'Button02': 'Slett prosjekt',
        'Button03_loading': '@:Shared.saving',
        'Button03': '@:Shared.save',
        'country_select_no_country': 'Ingen land',
      },
      'New project popup': {
        'Title': 'Nytt prosjekt',
        'Label01': '@:Projects.Shared.project_title',
        'Label02': '@:Projects.Shared.project_description',
        'Label03': '@:Projects.Shared.project_number',
        'Label04': '@:Projects.Shared.project_folder',
        'Label05': 'Ny prosjektmappe',
        'Label06': 'Legg til samling av tiltak fra start',
        'Label07': 'Velg samling',
        'Form_action_previous': 'Forrige',
        'Form_action_next': 'Neste',
        'Form_action_create': 'Opprett',
        'Form_action_cancel': 'Avbryt',
        'Form_action_skip': 'Hopp',
        'Select_country_label': 'Velg prosjektland',
        'Select_country_placeholder': 'Ingen land',
        'Section_info_title': 'Prosjektinformasjon',
        'Section_info_description': 'Legg inn grunnleggende informasjon om prosjektet ditt',
        'Section_frameworks_title': 'Velg rammeverk',
        'Section_frameworks_description': 'Velg et rammeverk som passer prosjektets bærekraftsmål og vurderingskriterier',
        'Section_action_collections_title': 'Velg tiltakssamling',
        'Section_action_collections_description': 'Velg en samling med forhåndsdefinerte tiltak som du kan bruke i prosjektet',
        'Section_question_collections_title': 'Velg spørsmålssamling',
        'Section_question_collections_description': 'Velg en samling med spørsmål for å kartlegge prosjektet',
        'Placeholder01': 'Prosjektgruppetittel',
        'Button01': '@:Shared.cancel',
        'Button02': '@:Shared.create',
        'country_select_no_country': 'Ingen land',
        'Select_goal_collection_title': 'Velg samling',
        'Select_goal_collection_description': 'Velg samling av målsettinger',
        'Compare_goal_collection_title': 'Sammenlign samlinger',
        'Compare_goal_collection_description': 'Sammenlign samlinger av målsettinger',
        'Switching_goal_collection_title': 'Bytter målsettinger',
        'Switching_goal_collection_default': 'Vennligst vent...',
        'Validation_title_required': 'Tittel er påkrevd',
      },
      'Share project popup': {
        'Title': 'Del prosjekt',
        'Manchet': 'Skriv emailen på den du ønsker at dele projektet med. Personen får adgang til projektet på lige vilkår med dig. (Men kan dog ikke dele det videre)',
        'InfoMessage01': 'Vær opmærksom på at den email du bruger skal være den eksakte mail som brugeren har oprettet sig med. Mail alias kan ikke bruges.',
        'Label01': 'E-post adresse',
        'Label02': 'Delt med',
        'Button01': 'Del',
        'Button02': 'Lukk',
      },
      'Copy project popup': {
        'Title': 'Kopier prosjekt',
        'Manchet': 'Et nyt prosjekt vil bli opprettet med samme innhold som dette prosjektet. Du vil være eier av det nye prosjektet.',
        'SuccessMessage': 'Prosjektet er kopiert',
        'ErrorMessage': 'Kunne ikke kopiere prosjektet',
        'Button01': '@:Shared.cancel',
        'Button02': '@:Shared.copy',
        'Button03': 'Gå til det nye prosjektet',
        'Button04': 'Prøv igjen',
      },
      'Version warning popup': {
        'Message': 'Dette projekt er gemt i en gammel version af Link Kompass. Ønsker du at opgradere projektet og få adgang til nyeste funktionalitet? (OBS! Du kan ikke længere se eller rette ambitionspoint på fokusområder)',
        'Button01': 'Fortsæt i gammel version',
        'Button02': 'Opgrader projekt',
      },
      'ExportPdf': {
        'Title': 'Eksporter til PDF',
        'SelectReport': 'Velg rapport',
        'OpenReport': 'Åpne rapport',
        'Download': 'Last ned PDF',
        'Cancel': 'Avbryt',
        'NoReports': 'Prosjektet har ingen rapport ennå. Opprett en rapport fra standardmalen for å eksportere.',
        'CreateReport': 'Opprett rapport',
        'Creating': 'Oppretter rapport...',
        'Generating': 'Lager PDF...',
        'Error': 'Kunne ikke lage PDF. Prøv igjen.',
        'CreateError': 'Kunne ikke opprette rapport.',
      },
    },
    'Workshop': {
      'Shared': {
        'Selected focus areas': 'Utvalgte fokusområder',
      },
      'Full screen rose chart': {
        'vision_and_effect_rose': 'Visjons- och effektrose',
        'select_framework': 'Velg rammeværk',
      },
      'Action': {
        'text': 'Tekst',
        'no_text': 'Ingen tekst',
        'tooltip_action_activate': 'Aktiver/deaktiver tiltak. (Deaktiverte tiltak inngår ikke i kompasset og er ikke synlige utenfor workshop)',
        'tooltip_action_park': 'Sett tiltak på vent til senere bruk. (Det finnes under P-ikonet på venstre side av skjermen)',
        'tooltip_action_edit': 'Rediger beskrivelse og vurdering av tiltaket',
        'tooltip_action_delete': 'Slett tiltaket (predefinerte tiltak kan opprettes igjen fra bilioteket)',
        'tooltip_action_remove': 'Fjern tiltak',
        'tooltip_action_add': 'Legg til tiltak',
      },
      'ActionAdded': {
        'SubcategoryActivated': 'Fokusområde aktivert',
        'SubcategoryActivatedMessage': 'Fokusområdet "{name}" ble aktivert for å akkommodere det lagte tiltaket.',
        'MultipleSubcategoriesActivatedTitle': '{count} fokusområder aktivert',
        'MultipleSubcategoriesActivated': '{count} fokusområder ble aktivert for å akkommodere de lagte tiltakene: {names}',
        'MultipleSubcategoriesActivatedWithMore': '{count} fokusområder ble aktivert for å akkommodere de lagte tiltakene: {names} og {count} til.',
      },
      'Goal': {
        'description': 'Beskrivelse',
      },
      'Page header': {
        'Title_normal': 'Workshopøkt',
        'Title_explore': 'Utforskningsøkt',
        'Button01_normal': 'Avslutt workshop',
        'Button01_explore': 'Avslutt økt',
        'Button02_show': 'Vis verktøytips',
        'Button02_hide': 'Skjul verktøytips',
        'Button03': 'Innsamlingslenke',
        'Button04': 'Eksporter',
        'Button05A': 'Åpne fullskjermmodus',
        'Button05B': 'Lukk fullskjermmodus',
        'Tab01': 'Prosjektmålsettinger',
        'Tab02': 'Kompass',
      },
      'Steps Navigation Toolbar': {
        'Button01': 'Forrige workshop trinn',
        'Button02': 'Velg workshop flow',
        'Button03': 'Neste workshop trinn',
      },
      'Steps': {
        'Step1Label': 'Lav visionsboard',
        'Step1Description': 'asdfælkjasdf',
        'Step2Label': 'Tegn visionsrose',
        'Step2Description': 'asdfælkjasdf',
        'Step3Label': 'Temaer',
        'Step3Description': 'asdfælkasdjfælkasf',
        'Step3bLabel': 'Bokvalitet',
        'Step3bDescription': 'asdfælkasdf',
        'Step4Label': 'Gennemse workshop resultater',
        'Step4Description': 'asdfælfksdj',
        'Step4bLabel': 'Overblik',
        'Step4bDescription': 'asdfælkasdf',
        'StepGuideSubStep1Label': 'Intro',
        'StepGuideSubStep2Label': 'Fokusområder',
        'StepGuideSubStep3Label': 'Tiltak',
        'StepGuideSubStep4Label': 'Ambitionsniveau',
      },
      'Compass panel': {
        'button_fullscreen_compass': 'Åpne compass i fullskjerm',
        'button_expand_panel': 'Vis panel',
        'button_collapse_panel': 'Skjul panel',
      },
      'Goal collections panel': {
        'title': 'Målsamlinger',
        'button_expand_panel': 'Vis målsamlinger',
        'button_collapse_panel': 'Skjul målsamlinger',
        'no_collections': 'Ingen målsamlinger tilgjengelig',
        'no_collection_selected': 'Ingen målsamling valgt',
        'switch_collection': 'Bytt målsamling',
        'switch_from_no_collection_message': 'Dette vil legge til en målsamling i prosjektet ditt. Hvis du har aktivert, deaktivert fokusområder og lagt til målbeskrivelser og -vurderinger, vil dette bli overskrevet. Vil du fortsette?',
        'switch_between_collections_message': 'Å bytte til denne målsamlingen vil overskrive alle eksisterende målvurderinger og beskrivelser. Vil du fortsette?',
      },
      'OverwriteCustomGoalsWarningModal': {
        'title': 'Advarsel om overskriving av egendefinerte mål',
        'description': 'Du har egendefinerte mål i dette prosjektet. Hvordan vil du håndtere dem når du bytter til en ny målsamling?',
        'option1_title': 'Slett alle egendefinerte mål',
        'option1_description': 'Start på nytt med den nye målsamlingen',
        'option2_title': 'Behold egendefinerte mål',
        'option2_description': 'Behold dine egendefinerte mål i kategorier hvor den nye samlingen også har et mål',
        'option3_title': 'Bruk nye samlingsmål',
        'option3_description': 'Bruk målet fra den nye samlingen i kategorier hvor du har lagt til et egendefinert mål',
      },

      'Summary panel': {
        'PanelTitle': 'Overblik',
        'Section1Title': 'Visionsboard',
        'Section2Title': 'Målsetting- og effektpoint',
      },
      'StepVisionboard': {
        'Question': 'Hvordan ser bærekraftsvisjonen ut for dette prosjektet?',
        'Description': 'Beskriv ved å legge til signaler, setninger og bilder på lerretet nedenfor.',
        'Frame01': 'Notater og bilder som beskriver visjonen',
        'Frame02': 'Dobbeltklikk hvor som helst for å legge til notat eller bilde',
        'Modal01': 'Legg til notat eller bilde',
        'Button01': 'Legg til notat',
        'Button02': 'Legg til bilde',
      },
      'StepVisionrose': {
        'Question': 'Hvor store er jeres målsettinger for hvert tema?',
        'Description': 'Klik eller træk på kompassets for at tegne jeres målsetting',
        'Tab01': 'Temabeskrivelser',
        'Tab02': 'Flere kompasser',
        'Explanation01': 'Ambisjonsnivået defineres manuelt ved å «dra» i rosen å gi en verdi mellom 1-100.',
        'Explanation02': '1 = svært lite viktig,',
        'Explanation03': '50 = middels viktig',
        'Explanation04': '100 = svært viktig.',
      },
      'StepThemeGuideFocusAreas': {
        'Title': 'velge fokusområder',
        'Question': 'Hvilke fokusområder vil du prioritere innenfor dette temaet?',
        'Description': 'Velg en rekke fokusområder nedenfor og vurder ambisjonsnivået ditt for hvert område.',
        'Section1Title': 'Mulige fokusområder',
        'Section2Title': 'Utvalgte fokusområder',
        'AddArea': 'Legg til fokusområde',
        'CustomTitle': 'Titel på fokusområde',
        'CustomDescription': 'Beskrivelse av fokusområde',
        'ConfirmDelete': '__DELETE__',
        'ConfirmRemove': 'Er du sikker på at du ikke vil prioritere dette fokusområdet? Tiltak under dette fokusområdet vil da fjernes fra "Tilførte tiltak".',
        'Custom': 'Egendefinert',
      },
      'EditSubCategoryGoalModal': {
        'Title': 'Rediger målsetting',
        'GoalInfo': 'Målinformasjon',
        'SubCategory': 'Fokusområde',
        'Collection': 'Målsamling',
        'Description': 'Beskrivelse',
        'DescriptionPlaceholder': 'Skriv inn beskrivelse av målsettingen...',
        'Rating': 'Vurdering',
        'RatingHelp': 'Vurdering fra -10 til +10, hvor 0 er nøytralt',
        'RatingPreview': 'Forhåndsvisning av vurdering',
      },
      'StepThemeGuideAmbition': {
        'Title': 'legge til tiltak',
        'Question': 'Hvor er dit ambitionsniveau for dette tema?',
        'Description': 'Sæt et ambitionsniveau der passer til dit projekt og se foreslåede tiltag baseret på dine valgte fokusområder og ambitionsniveau',
        'Section_ambition_rating_title': 'Ambisjonsnivå',
        'Section_recommended_actions_title': 'Anbefalte tiltak',
        'Section_ambition_rating_unit': 'Prosent',
        'Section_ambition_rating_description': 'Ambisjonsnivået defineres manuelt ved å «dra» i rosen å gi en verdi mellom 1-100. <br />1 = svært lite viktig, <br />50 = middels viktig, <br />100 = svært viktig.',
      },
      'StepThemeGuideActions': {
        'Title': 'legge til tiltak',
        'Question': 'Hvilke tiltak vil du ta for å nå dine ambisjoner for fokusområdene?',
        'Description': 'Velg tiltak fra listen og dra dem over til de enkelte fokusområdene.',
        'AvailableActions': 'Mulige tiltak',
        'SelectedActions': 'Utvalgte tiltak',
        'AddAction': 'Legg til tiltag',
      },
      'StepSummary': {
        'Question': 'Slik ser prosjektets bærekraftsprofil ut',
        'Description': 'Du kan eksportere profilen som en rapport',
        'BarChartTitle': 'Tiltak per tema',
      },
      'StepSurvey': {
        'QuestionLabel': 'Vurder i hvilken grad du har oppfylt underkriteriene nedenfor',
        'CommentLabel': 'Valgfri begrunnelse til svaret ditt',
        'CustomQuestionLabel': 'Tilføj dine kriterier og vurdering',
        'AddCustomCriteria': 'Legg til egne kriterier',
        'NoCustomCriteria': 'Ingen egendefinerte kriterier lagt til ennå',
        'CustomCriteriaTitle': 'Tilleggskriterier',
        'CriteriaTitle': 'Tittel',
        'CriteriaTitlePlaceholder': 'Skriv inn tittel for kriteriet',
        'CriteriaDescription': 'Begrunnelse',
        'CriteriaDescriptionPlaceholder': 'Valgfri begrunnelse til svaret ditt',
        'VoteType': 'Vurderingstype',
        'SelectSubCategory': 'Velg underkategori',
        'SelectSubCategoryPlaceholder': 'Velg hvilken underkategori kriteriet tilhører',
        'Cancel': 'Avbryt',
        'AddCriteria': 'Legg til kriterium',
        'CreateError': 'Det oppstod en feil ved opprettelse av kriteriet',
        'EditCriteria': 'Rediger kriterium',
        'EditCustomCriteria': 'Rediger egendefinert kriterium',
        'DeleteCriteria': 'Slett kriterium',
        'DeleteConfirmMessage': 'Er du sikker på at du vil slette dette kriteriet? Denne handlingen kan ikke angres.',
        'SaveChanges': 'Lagre endringer',
      },
      'Goals view': {
        'Button01': 'Legg til målsetting',
      },
      'Matrix view': {
        'Button01': 'Legg til tiltak',
        'Button01_tooltip': 'Legg til forslag til tiltak og flytt til kompass eller sett på vent til senere bruk (ALT+CTRL+t)',
        'Button02_hide': 'skjul tiltak',
        'Button02_show': 'vis tiltak',
        'Button02_tooltip': 'Skjul alle tiltak for å få bedre oversikt over temaer og undertemaer',
        'Button03_all': 'vis alle undertema',
        'Button03_chosen': 'vis bare valgte undertema',
        'Button03_tooltip': 'Få mer oversikt ved å sortere undertemaer slik at du bare ser de som er valgt (du kan velge et undertema ved å klikke på tittelen)',
        'Button04_tooltip': 'Zoom inn (ALT+CTRL+i)',
        'Button05_tooltip': 'Zoom ut (ALT+CTRL+u)',
        'Compass': 'Kompass',
      },
      'Category view': {
        'Button01': 'Legg til tiltak',
        'Button01_tooltip': 'Legg til forslag til tiltak og flytt til kompass eller sett på vent til senere bruk (ALT+CTRL+t)',
        'Button02_all': 'vis alle undertemaer',
        'Button02_chosen': 'vis bare valgte undertemaer',
        'Button02_tooltip': 'Få mer oversikt ved å sortere undertemaer slik at du bare ser de som er valgt (du kan velge et undertema ved å klikke på tittelen)',
      },
      'Export popup': {
        'Button01': '@:Shared.cancel',
        'Button02': 'Eksporter word',
        'Button03': 'Eksporter CSV',
        'Button04': 'Eksporter bilde',
      },
      'Collect actions link popup': {
        'Title': 'Lenke til innsamling av brukerforslag',
        'Button01': '@:Shared.cancel',
      },
      'Edit action popup': {
        'Title': 'Rediger tiltak',
      },
      'Add action popup': {
        'Title': 'Legg til nytt forslag til tiltak',
        'No_actions': 'Ingen tiltak matchet søket. Prøv et annet søk.',
        'Textarea01_placeholder': 'Beskrivelse av tiltaket',
        'Button01': '@:Shared.cancel',
        'Button02': 'Legg til og sett på vent',
        'Button03': 'Legg til',
      },
      'Edit workshop steps popup': {
        'Title': 'Vælg relevante trin til din workshop',
        'Description': 'Du kan tilføye trin (delprocesser) til din workshop ved at vælge fra listen til høyre. Nogle trin har også under-trin som du kan vælge tril eller fra. Du kan godt tilføye det samme trin mere en gang. Dette kan f.eks. give mening hvis du ønsker at have én temaguide med fokus på fokusområder og en med fokus på tiltag.',
        'Section1Title': 'Valgte workshoptrin',
        'Section2Title': 'Mulige workshoptrin',
        'SaveButton': 'Gem',
        'CancelButton': 'Fortryd',
        'ValidationError1': 'Du mangler at vælge mindst en undersection på et av de valgte trin',
      },
      'Mobile user warning popup': {
        'Message': 'Workshopøkt fungerer ikke på mobil',
        'BackButton': 'Tilbake',
      },
      'Chart panel': {
        'Button01_tooltip': 'Vis kompass med en visuell oversikt over godkjente tiltak og deres vurdering',
        'SectionTitle01': 'Tiltag',
        'SectionTitle02': 'Prioritering av temaer',
        'SectionTitle03': 'Valgte målsettinger',
      },
      'Library panel': {
        'Button01_tooltip': 'Vis / lukk biblioteket med forslag til tiltak',
        'Dropdown01_placeholder': 'Velg tema',
        'Dropdown02_placeholder': 'Velg undertema',
        'Dropdown03_placeholder': 'Alle tema',
        'Dropdown04_placeholder': 'Alle samlinger',
        'Toggle01_label': 'Vis anbefalinger øverst',
        'InfoMessage01': 'Vær oppmerksom på at du godt kan legge til det samme tiltaket i flere kategorier, tiltaket vil da telle i begge kategoriene hvor det er lagt til. Har du lagt til det samme tiltaket under forskjellige kategorier kan du etterfølgende endre i de to tiltakenes rangering uavhengig av hverandre.',
        'MessageNoActions': 'Ingen tiltak i denne kategorien',
        'Error01': 'Kunnne ikke laste inn tiltak',
      },
      'Collected actions panel': {
        'InfoMessage01': 'Her kan du se tiltak som har blitt samlet inn via innsamlingslenken (Finn innsamlingslenken ved å klikke på talebobleikonet øverst til høyre). Tilføyde tiltak vil bli plassert i kategorien "Annet". ',
      },
      'Parking panel': {
        'Button01_tooltip': 'Vis / lukk tiltak på vent. Her kan du sette tiltak på vent for senere bruk',
        'Dropdown01_placeholder': 'Velg tema',
        'Dropdown02_placeholder': 'Velg undertema',
        'MessageInfo': 'Du kan plassere foreslåtte tiltak til senere diskusjon enten ved å dra tiltaket over i parkeringsplassen eller ved å velge tiltaket og klikke på parkeringsikonet',
      },
      'User actions panel': {
        'Button01_tooltip': 'Vis / lukk liste over innsamlede forslag fra brukere. Her er også instruksjoner om hvordan du samler inn forslag.',
        'MessageInfo': 'Du kan samle inn forslag fra workshopdeltakere ved å klikke på \'Innsamlingslenke\' øverst i høyre hjørne',
      },
    },
    'Report': {
      'Headers': {
        'Title': 'Digital rapport',
        'Actions': 'Tiltak',
        'Questions': 'Kriterier',
        'ObligatoryQuestions': 'Obligatoriske kriterier',
        'CustomQuestions': 'Tilleggskriterier',
        'Board': 'Prosjektets visjon',
      },
      'Elements': {
        'Tab01': 'Data',
        'Tab02': 'Tema',
        'Tab03': 'Layout',
        'Project title': 'Prosjekt tittel',
        'Project description': 'Prosjekt beskrivelse',
        'Project number': 'Prosjekt nummer',
        'board': 'Visjonsboard',
        'intro': 'Tema introduksjon',
        'actions': 'Tiltak',
        'questions': 'Under-kriterier',
        'subcategories': 'Fokusområder',
        'compass': 'Kompass',
        'h1': 'Heading 1',
        'h2': 'Heading 2',
        'h3': 'Heading 3',
        'paragraph': 'Paragraph',
        'threecolumns': 'Layout 3 cols',
        'twocolumns': 'Layout 2 cols',
        'rose': 'rose',
        'categorylist': 'tema-liste',
      },
      'Toolbar': {
        'Button01': 'Lagre rapport',
        'Button02': 'Del rapport',
        'Button03': 'Kopier rapport',
        'Button04': 'Forhåndsvisning',
        'Button05': 'Oppdater data i rapporten',
        'Button06': 'Last inn standardrapport',
        'Button07': 'Lag en kopi av rapporten',
        'Button08': 'Ny tom rapport',
        'Button09': 'Lagre som mal',
        'Button10': 'Last inn mal',
      },
      'Templates': {
        'Title': 'Velg mal',
        'SaveTitle': 'Lagre som mal',
        'Name': 'Navn på mal',
        'Visibility': 'Hvem kan bruke malen',
        'VisibilityPrivate': 'Kun meg',
        'VisibilityOrganization': 'Min organisasjon',
        'VisibilityPublic': 'Alle',
        'Default': 'Standardrapport',
        'ReplaceWarning': 'Når du laster inn en mal, erstattes innholdet i rapporten.',
        'Use': 'Bruk',
        'Rename': 'Gi nytt navn',
        'Delete': 'Slett',
        'ConfirmDelete': 'Er du sikker?',
        'Save': 'Lagre',
        'Cancel': 'Avbryt',
        'Empty': 'Ingen maler tilgjengelig',
        'Saved': 'Malen er lagret',
        'Error': 'Noe gikk galt. Prøv igjen.',
      },
      'Share': {
        'Title': 'Del rapport',
        'Manchet': 'Del rapporten med andre ved å kopiere lenken under og aktivere',
        'ManchetBokvalitet': 'Kopier lenken under og send den til saksbehandler i kommunen. Da får kommunen tilgang til vurderingen i Bokvalitetsrosen og kan gi kommentarer og tilbakemeldinger. Du finner tilbake til rapporten med eventuelle kommentarer under fanen Rapporter i prosjektet.',
        'ShareTextExplanationBokvalitet': 'Forslag til epost til saksbehandler i kommunen',
        'ShareTextBokvalitet': 'Hei [saksbehandler],\n\nHer kommer lenke til digital rapport fra Bokvalitetsrosen for prosjektet [Prosjektnavn]. Rapporten gir en vurdering av bokvalitet i prosjektet, og vi ønsker kommunens innspill og en god dialog om resultatene.\n\nDu kan lese rapporten og legge inn kommentarer direkte i verktøyet.\n\n👉 [Lenke til rapporten]\n\nViktig: Du må være logget inn for å kunne kommentere. Dersom du ikke har bruker fra før, kan du opprette konto via samme lenke.\n\nNår du har fullført kommenteringen og har tilbakemeldinger, setter jeg pris på om du sender meg en e-post, slik at vi kan følge opp videre.\n\nVennlig hilsen [deg]',
        'Expiration': 'Valgfri utløpsdato for rapporten',
        'Visibility': 'Personer med lenken kan se dataene',
        'AllowComments': 'Registrerte brukere med lenken kan kommentere på rapporten',
        'AllowUnregisteredCommenters': 'Alle kan kommentere på rapporten uten å være registrert',
        'Button01': 'Avbryt',
      },
      'Preview': {
        'Title': 'Forhåndsvisning',
        'Button01': 'Avbryt',
      },
      'SharedReport': {
        'Title': 'Digital rapport',
        'Label01': 'Prosjekt tittel',
        'Label02': 'Prosjekt nummer',
        'Label03': 'Rapport oppdatert',
      },
      'Designer': {
        'Header': {
          'NoReports': 'Ingen rapporter lagret',
          'NotSavedReport': 'ændringer som ikke er lagret',
          'NotSavedReportWarning': 'Er du sikker på at du vil forlate denne siden? Du har ulagrede endringer.',
        },
        'Report': 'Rapport',
      },
      'Comment': {
        'Comments': 'Kommentarer',
        'AddComment': 'Legg til kommentar',
        'WritePlaceholder': 'Skriv en kommentar her...',
        'Cancel': 'Avbryt',
        'Submit': 'Send',
        'Reply': 'Svar',
        'NamePlaceholder': 'Navnet ditt',
        'NameDescription': 'Legg til navnet ditt for å begynne å kommentere',
        'ReplyPlaceholder': 'Skriv svaret ditt her',
        'ShowAll': 'Vis alle kommentarer',
        'LoginToComment': 'Logg inn for å kommentere',
        'ClickElementToComment': 'Klikk på elementet for å kommentere',
        'ShowingAllComments': 'Viser alle kommentarer',
        'NoComments': 'Ingen kommentarer',
      },
    },
    'Explore mobile': {
      'Choose project popup': {
        'Title01': '@:Shared.projects',
        'Manchet01': 'Velg mellom prosjekteksempler som utgangspunkt eller opprett et nytt prosjekt',
        'EmptyProjectTitle': 'Opprett et nytt prosjekt',
      },
      'Categories and actions view': {
        'Tab01': 'Tema',
        'Tab02': 'Tiltak',
        'MessageNoActions': 'Legg til tiltak ved å klikke på \'+ Tiltak\' øverst i høyre hjørne',
      },
      'Panel': {
        'Tab01': 'Fra bibliotek',
        'Tab02': 'Tilpasset',
        'Textarea01_placeholder': 'Beskriv tiltaket',
        'Label01': 'Hvilket tema hører forslaget ditt under?',
        'Button01': 'Legg til tiltak',
        'Button02': 'Fjern markeringen av tiltak',
        'Button03': 'Legg til valgte tiltak',
        'Button04': 'Hent flere tiltak',
        'Button05': 'Legg til tiltak',
        'MessageAllAdded': 'Alle tiltak i denne kategorien er lagt til i kompasset',
      },
    },
    'Guest': {
      'Contributions view': {
        'Title': 'Bidra med forslagene dine',
        'Button01': 'nytt forslag',
        'MessageNoSuggestions': 'klikk på knappen: "nytt forslag"',
      },
      'Add suggestion popup': {
        'Title': 'Legg til nytt forslag til tiltak',
        'Textarea01_placeholder': 'Beskriv forslaget ditt',
        'Button01': '@:cancel',
        'Button02': 'Sende inn',
      },
    },
    'Users': {
      'Login view': {
        'MessageLoading': '@:Shared.loading',
        'Title01': 'Logg inn',
        'Title02': 'Logg inn med e-post adresse',
        'Label01': 'E-post adresse',
        'Input01_placeholder': 'linkarkitektur mail',
        'Label02': 'Passord',
        'Input02_placeholder': 'Passord',
        'Button01': 'Logg inn',
        'Button01_loading': 'Logger inn',
        'Button02': 'Logg inn med e-post adresse',
        'Button02_loading': '',
        'Link01': 'Oprette ny bruker?',
        'Link02': 'Glemt passord?',
        'Link02_alt': 'Logg inn med passord',
        'MessageEmailSent': 'E-post er sendt',
        'ErrorMessage01': 'Kan ikke logge ind. Tjek dine oplysninger',
        'ErrorMessage02': 'Der opstod en fejl ved login. Prøv igen.',
      },
      'Signup view': {
        'Title01': 'Oprett ny bruker',
        'Label01': 'Fullt navn',
        'Input01_placeholder': 'Kari Normann',
        'Label02': 'E-post adresse',
        'Input02_placeholder': 'linkarkitektur mail',
        'Label03': 'Passord',
        'Input03_placeholder': 'Passord',
        'Button01': 'Opprett',
        'InfoMessage01': 'Vær opmærksom på at systemet ikke kender eventuelle email alias. Det er altså den eksakte email du skriver her der senere skal bruges til at logge ind, samt hvis andre vil dele et projekt med dig.',
        'ErrorMessage01': 'Domain not allowed',
        'ErrorMessage02': 'Kunne ikke logge ind. Det kan f.eks. skyldes at din bruger allerede eksisterer.',
      },
      'Password view': {
        'Input_new_password_label': 'Nytt passord',
        'MessageSuccess': 'Passordet ble endret',
      },
    },
    'Organizations': {
      'All organizations view': {
        'Organization_card_contact_person': 'Kontaktperson',
        'Organization_card_contact_phone': 'Telefonnummer',
        'Organization_card_contact_email': 'E-post adresse',
        'Section_admin_users_title': 'Admin brukere',
        'Organization_card_parent': 'Overordnet organisasjon',
        'Organization_hierarchy_title': 'Organisasjonshierarki',
        'Switch_to_list': 'Bytt til listevisning',
        'Switch_to_hierarchy': 'Bytt til hierarkivisning',
        'Organization_hierarchy': 'Organisasjonsstruktur',
        'Organization_list': 'Organisasjonliste',
      },
      'Popups': {
        'Create_title': 'Ny organisasjon',
        'Edit_title': 'Rediger organisasjon',
        'Input_org_name_validation': 'Organisasjonsnavn er påkrevd.',
        'Section_basic_info_title': 'Grunnleggende informasjon',
        'Section_main_contact_title': 'Hovedkontakt',
        'Section_users_title': 'Brukere',
        'Section_frameworks_title': 'Frameworks',
        'Section_workshop_steps_title': 'Workshop steg',
        'Section_basic_info_description': 'Legg til grunnleggende informasjon om organisasjonen',
        'Section_users_description': 'Inviter en eller flere personer til å bli admin i den nye organisasjonen',
        'Section_frameworks_description': 'Velg hvilke rammeværk som skal være tilgjengelige for denne organisasjonen',
        'Section_workshop_steps_description': 'Velg hvilke workshop-steg som skal være tilgjengelige for denne organisasjonen og legg til dem i standard workshop-flyten (workshop-steg som er en del av standard workshop-flyten må være valgt)',
        'Select_parent_organization': 'Velg eventuell eksisterende organisasjon som denne organisasjonen skal være under',
        'No_parent_organization': 'Ingen (denne organisasjonen er toppnivå)',
        'Organization_hierarchy': 'Organisasjonshierarki',
        'Organization_no_parent': 'Ingen overordnet organisasjon',
        'Child_organizations': 'Underordnede organisasjoner',
        'Input_main_contact_name_validation': 'Navn er påkrevd.',
        'Input_main_contact_email_validation': 'Ugyldig e-postformat.',
        'Input_main_contact_phone_validation': 'Telefonnummer er påkrevd.',
        'Section_org_admins_description': 'Inviter en eller flere personer til å bli admin i den nye organisasjonen',
        'Input_org_admins_validation': 'Navn og e-post er påkrevd for alle administratorer.',
        'Form_action_create': 'Opprett organisasjon',
        'Form_action_next': '@:Shared.next',
        'Form_action_previous': '@:Shared.previous',
        'Button_edit': '@:Shared.edit',
        'Button_cancel': '@:Shared.cancel',
        'Button_save': '@:Shared.save',
        'Create_status_success': 'Organisasjonen ble opprettet',
        'Create_status_error': 'Kunne ikke opprette organisasjonen',
        'Create_status_loading': 'Oppretter organisasjon...',
        'Create_status_all_fields_required': 'Alle felt er påkrevd',
        'Update_status_success': 'Organisasjonen ble oppdatert',
        'Update_status_error': 'Oppdatering av organisasjonen feilet',
        'Update_status_loading': 'Oppdaterer organisasjon...',
        'Update_status_no_change': 'Ingen endringer ble gjort',
        'IsDefaultFramework': 'Standard rammeværk',
        'MakeDefaultFramework': 'Gjør til standard',
        'Validation_error_no_frameworks_selected': 'Du må velge minst et rammeværk.',
        'Validation_error_no_default_framework_selected': 'Giv organisasjonen tilgang til rammeværket for å kunne bruke det som standard.',
        'Section_default_workshop_flow_title': 'Standard workshop-flyt',
        'Section_default_workshop_flow_description': 'Customiser standard workshop-flyten for denne organisasjonen',
        'Section_available_workshop_steps_title': 'Tilgjengelige workshop-steg',
        'Section_available_workshop_steps_description': 'Velg hvilke workshop-steg som skal være tilgjengelige for denne organisasjonen og legg til dem i standard workshop-flyten (workshop-steg som er en del av standard workshop-flyten må være valgt)',
        'Toggle_users_can_edit_default_workshop_steps_label': 'Tillat brukere å redigere standard workshop-steg',
        'Toggle_all_workshop_steps_enabled_label': 'Aktiver alle',
        'Confirm_unsaved_changes': 'Du har gjort endringer som ikke er lagret. Er du sikker på at du vil forlate denne siden?',
        'Warning_fix_errors': 'Du må fikse feilene før du kan lagre',
        'No_admin_user_validation': 'Du må ha minst en admin-bruker i organisasjonen',
        'Confirm_inactive_admin': 'Siden brukeren ennå ikke er aktivert, vil dette fjerne brukeren og gjøre invitasjonen ugyldig?',
        'Message_cant_delete_active_user': 'På dette tidspunktet kan du ikke slette aktive brukere her. Du kan slette brukere i din egen organisasjon under brukeradministrasjonen.',
        'Section_question_collections_description': 'Velg en valgfri samling å legge til i prosjektet.',
      },
      'Archive': {
        'Delete_title': 'Slett organisasjon',
        'Delete_confirm_intro': 'Du er i ferd med å arkivere {name}.',
        'Delete_warning_users': 'Alle brukere i denne organisasjonen vil bli permanent slettet.',
        'Delete_warning_projects': 'Alle prosjekter vil bli frakoblet brukere.',
        'Delete_warning_archived': 'Organisasjonen vil bli markert som arkivert.',
        'Delete_confirm_instruction': 'Skriv {confirmText} for å bekrefte.',
        'Delete_confirm_label': 'Bekreftelsestekst',
        'Delete_confirm_validation': 'Vennligst skriv "I want to delete" nøyaktig.',
        'Delete_button': 'Slett organisasjon',
        'Restore_title': 'Gjenopprett organisasjon',
        'Restore_intro': 'For å gjenopprette {name}, opprett den første org-admin nedenfor.',
        'Restore_description': 'Dette kjøres som én handling: opprett admin-bruker, deretter gjenopprett organisasjonen og tilordne arkiverte prosjekter til denne admin.',
        'Restore_admin_name_label': 'Navn på første org-admin',
        'Restore_admin_email_label': 'E-post for første org-admin',
        'Restore_validation': 'Vennligst oppgi et gyldig navn og e-post.',
        'Restore_button': 'Gjenopprett organisasjon',
        'Archived_badge': 'Arkivert',
        'Restore_button_short': 'Gjenopprett',
        'Delete_button_short': 'Slett',
        'Delete_status_loading': 'Sletter organisasjon...',
        'Delete_status_success': 'Organisasjonen ble arkivert.',
        'Delete_status_error_children': 'Organisasjonen har underordnede organisasjoner. Fjern eller omfordel underordnede først.',
        'Delete_status_error_forbidden': 'Du har ikke tillatelse til å slette denne organisasjonen.',
        'Delete_status_error_not_found': 'Organisasjonen ble ikke funnet.',
        'Delete_status_error_generic': 'Kunne ikke slette organisasjonen.',
        'Restore_status_loading': 'Gjenoppretter organisasjon...',
        'Restore_status_success': 'Organisasjonen ble gjenopprettet.',
        'Restore_status_error_conflict': 'En konto med denne e-postadressen finnes allerede.',
        'Restore_status_error_forbidden': 'Du har ikke tillatelse til å gjenopprette denne organisasjonen.',
        'Restore_status_error_generic': 'Kunne ikke gjenopprette organisasjonen.',
        'Cancel': '@:Shared.cancel',
      },
    },
    'UserAdmin': {
      'User list': {
        'Title': 'Brukere',
        'Button_create_user_label': 'Opprett ny bruker i organisasjonen din',
      },
      'Edit user popup': {
        'Title': 'Rediger bruker',
        'Section_user_name_title': 'Brukernavn',
        'Section_contact_info_title': 'Kontaktinformasjon',
        'Input_contact_email_placeholder': 'E-post',
        'Input_contact_phone_placeholder': 'Telefon',
        'Button_delete': 'Slett',
        'Button_edit': 'Rediger',
        'Button_cancel': 'Avbryt',
        'Button_save': 'Lagre',
        'Button_make_admin': 'Gjør til admin',
        'Button_revoke_admin': 'Fjern admin',
        'Status_success': 'Brukeren ble oppdatert',
        'Status_error': 'Oppdatering av brukeren feilet',
        'Status_loading': 'Oppdaterer bruker...',
        'Status_delete_success': 'Brukeren ble slettet',
        'Status_delete_error': 'Sletting av brukeren feilet',
        'Status_no_change': 'Ingen endringer ble gjort',
        'Confirm_delete_user': 'Er du sikker på at du vil slette denne brukeren?',
        'Confirm_make_admin': 'Er du sikker på at du vil gjøre denne brukeren til admin?',
        'Confirm_revoke_admin': 'Er du sikker på at du vil fjerne admin-rettigheter fra denne brukeren?',
        'Confirm_revoke_own_admin': 'Er du sikker på at du vil fjerne dine egne admin-rettigheter?',
      },
      'Create user popup': {
        'Title': 'Opprett ny bruker',
        'Section_user_name_title': 'Brukernavn',
        'Section_contact_info_title': 'Kontaktinformasjon',
        'Input_contact_email_placeholder': 'E-post',
        'Input_contact_phone_placeholder': 'Telefon',
        'Form_action_create': 'Opprett bruker',
        'Status_success': 'Brukeren ble opprettet',
        'Status_error': 'Kunne ikke opprette brukeren',
        'Status_loading': 'Oppretter bruker...',
        'Status_all_fields_required': 'Alle felt er påkrevd',
        'Input_user_name_validation': 'Brukernavn er påkrevd.',
        'Input_contact_email_validation': 'Ugyldig e-postformat.',
        'Input_contact_phone_validation': 'Telefonnummer er påkrevd.',
      },
    },
    'Collections': {
      'Add collection': 'Legg til samling',
      'New collection': 'Ny samling',
      'No collections available': 'Ingen samlinger tilgjengelige',
    },
    'Action designer': {
      'Tabs': {
        'All actions': 'Alle tiltak',
        'Collections': 'Samlinger',
      },
      'Framework': {
        'Select framework': 'Velg rammeverk',
      },
      'Actions': {
        'button_add_action': 'Legg til tiltak',
        'delete_action_warning': 'Er du sikker? Når du sletter en standard handling, vil den ikke lenger være synlig i biblioteket, og den vil bli fjernet fra samlinger. Kompasser hvor handlingen ble lagt til vil ikke endres.',
        'no_collections_message': 'ikke i noen samlinger',
        'missing_sub_category_message': 'Mangler fokusområde',
      },
      'New collection popup': {
        'Title': 'Ny samling',
        'Label01': 'Samlingens navn',
        'Label02': 'Velg rammeverk',
        'Button01': 'Avbryt',
        'Button02': 'Lagre',
        'Created message': 'Ny samling opprettet',
        'Status_loading': 'Oppretter samling...',
        'Status_success': 'Samlingen ble opprettet',
        'Status_error': 'Kunne ikke opprette samlingen',
      },
      'Collection': {
        'Button01': 'Lag en kopi',
        'Button02': 'Slett',
        'Button01_tooltip': 'Lag en kopi av en samling.',
        'Button02_tooltip': 'Slett samling, for alle brugere.',
        'isEnabled': 'Samlingen er aktivert',
        'isNotEnabled': 'Samlingen er i utkastmodus',
        'noActions': 'Ingen handlinger i denne kategorien',
        'DeleteConfirm': 'Er du sikker på at du vil slette denne samlingen?',
      },
      'Manage collection access popup': {
        'title': 'Administrer samlingstilgang',
        'Section_visibility_description': 'Velg hvem som har lov til å bruke denne samlingen',
        'Select_visibility_placeholder': 'Velg synlighet',
        'Section_organization_description': 'Velg i hvilke land samlingen er synlig. Landet er satt når du oppretter et nytt kompass.',
        'Section_organizations_description': 'Velg hvilke organisasjoner som har tilgang',
        'Select_visibility_option_private_label': 'Kun meg',
        'Select_visibility_option_organization_label': 'Alle i organisasjonen min',
        'Select_visibility_option_organizations_label': 'Valgte organisasjoner',
        'Select_visibility_option_public_label': 'Alle kan bruke',
        'Update successful': 'Oppdatering vellykket',
        'Update failed': 'Kunne ikke oppdatere',
      },
      'Copy collection popup': {
        'Title': 'Kopier samling',
        'Manchet': 'En ny samling med de samme handlingene vil bli opprettet.',
        'SuccessMessage': 'Samlingen ble kopiert',
        'ErrorMessage': 'Kunne ikke kopiere samlingen',
        'Button01': '@:Shared.cancel',
        'Button02': '@:Shared.copy',
        'Button03': 'Gå til den nye samlingen',
        'Button04': 'Prøv igjen',
      },
    },
    'Goal designer': {
      'Add goal collection': 'Legg til samling',
      'EditGoalSubCategory': 'Rediger mål',
      'Tabs': {
        'All collections': 'Alle samlinger',
      },
      'Collection': {
        'Button01': 'Lag en kopi',
        'Button02': 'Slett',
        'Button01_tooltip': 'Lag en kopi av en samling.',
        'Button02_tooltip': 'Slett samling, for alle brugere.',
        'enabled goals': 'aktive mål',
        'isEnabled': 'Samlingen er aktivert',
        'isNotEnabled': 'Samlingen er i utkastmodus',
        'DeleteConfirm': 'Er du sikker på at du vil slette denne samlingen?',
      },
      'New goal collection popup': {
        'Title': 'Ny samling',
        'Label01': 'Samlingens navn',
        'Label02': 'Samlingens rammeverk',
        'Button01': 'Avbryt',
        'Button02': 'Lagre',
        'Status_loading': 'Oppretter samling...',
        'Status_success': 'Samlingen ble opprettet',
        'Status_error': 'Kunne ikke opprette samlingen',
      },
    },
    'Cms': {
      'Shared': {
        'MessageNoTranslation': 'Ingen oversætting',
        'MessageNotEditable': 'Kan ikke redigeres her',
      },
      'Main view': {
        'Tab01': 'Standard tiltak',
        'Tab02': '@:Shared.category & @:Shared.subcategory',
        'Tab03': 'Tekster',
        'Tab04': 'Rapport tekstbidder',
        'Tab05': 'Frameworks',
      },
      'Standard actions view': {
        'Button01': 'Legg til standard tiltak',
        'Button03': 'Hent flere tiltak',
      },
      'Categories view': {
        'Button01': '@:Shared.edit @:Shared.category',
        'Button02': '@:Shared.edit @:Shared.subcategory',
        'MessageNoTranslation': 'No translation',
      },
      'Category view': {
        'Button01': 'Rediger tema',
        'Button02': 'Slett undertema',
        'Button03': 'Rediger undertema',
      },
      'Edit category popup': {
        'Title': 'Rediger @:Shared.category',
        'Label01': '@:Shared.category titel',
        'Label01A': 'Reference tekst',
        'Label02': '@:Shared.category beskrivelse',
        'Label03': 'Farve hex kode',
        'Label03A': 'Farve eksempel',
        'Button01': '@:Shared.cancel',
        'Button02': 'Slett @:Shared:category',
        'Button03': '@:Shared.save',
        'Button03_loading': '@:Shared.saving',
      },
      'Edit subcategory popup': {
        'Title': 'Rediger @:Shared.subcategory',
        'Label01': '@:Shared.subcategory titel',
        'Label01A': 'Reference tekst',
        'Label02': '@:Shared.subcategory beskrivelse',
        'Label03': 'Farve hex kode',
        'Label03A': 'Farve eksempel',
        'Button01': '@:Shared.cancel',
        'Button02': 'Slett @:Shared.subcategory',
        'Button03': '@:Shared.save',
        'Button03_loading': '@:Shared.saving',
        'Button03_saved': 'Lukk',
      },
      'Edit standard action popup': {
        'Title': 'Rediger @:Shared.standard_action',
        'Label01': '@:Shared.description',
        'Label01A': 'Reference tekst',
        'Label02': '@:Shared.ratings',
        'Reference info': 'Referanseteksten er bare her for å gjøre oversettelsen enklere',
        'Button01': '@:Shared.cancel',
        'Button02': 'Slett @:Shared.action',
        'Button03': '@:Shared.save',
        'Button03_loading': '@:Shared.saving',
        'Button03_saved': 'Lukk',
      },
    },
    'Frameworks': {
      'LINK Bærekraftstemaer': 'LINK Bærekraftstemaer',
      'Impact Architecture': 'Impact Architecture',
      'FNs bærekraftsmål': 'FNs bærekraftsmål',
      'title': 'Rammeverk',
      'subtitle': 'Administrer og tilpass rammeverk for bærekraftsvurdering',
      'create_new': 'Opprett rammeverk',
      'edit': 'Rediger',
      'status_enabled': 'Aktivert',
      'status_disabled': 'Deaktivert',
      'categories': 'Kategorier',
      'filter_by_country': 'Filtrer etter land',
      'filter_all_countries': 'Alle land',
    },
    'Framework Designer': {
      'title': 'Rammeverk Designer',
      'framework_details': 'Rammeverk Detaljer',
      'framework_name': 'Rammeverk Navn',
      'framework_name_placeholder': 'Skriv inn rammeverk navn',
      'max_value': 'Maksimal Verdi',
      'steps': 'Trinn',
      'view_mode': 'Visningsmodus',
      'enabled': 'Rammeverk Aktivert',
      'categories': 'Kategorier',
      'add_category': 'Legg til Kategori',
      'edit_category': 'Rediger Kategori',
      'layer_configuration': 'Lagkonfigurasjon',
      'layer_label': 'Lagetikett',
      'data_source': 'Datakilde',
      'opacity': 'Gjennomsiktighet',
      'round_to_step': 'Avrund til Trinn',
      'add_layer': 'Legg til Lag',
      'preview': 'Forhåndsvisning',
      'preview_not_available': 'Legg til kategorier og konfigurer lag for å se forhåndsvisning',
      'save': 'Lagre Rammeverk',
      'country_label': 'Tilgjengelig i land',
      'country_all': 'Alle land',
      'save_success': 'Rammeverk lagret',
      'save_error': 'Feil ved lagring av rammeverk',
      'layer_1': 'Lag 1',
      'layer_2': 'Lag 2',
      'layered': 'Lagdelt',
      'stacked': 'Stablet',
      'user_ratings': 'Brukervurderinger',
      'action_ratings': 'Tiltaksvurderinger',
      'objective_ratings': 'Objektive Vurderinger',
      'subjective_ratings': 'Subjektive Vurderinger',
      'back': 'Tilbake',
      'settings': 'Innstillinger',
      'workshop_steps': 'Workshop Trinn',
      'available_workshop_steps': 'Tilgjengelige Workshop Trinn',
      'default_workshop_flow': 'Standard Workshop Flyt',
      'add_subcategory': 'Legg til Underkategori',
      'confirm_delete_subcategory': 'Er du sikker på at du vil slette denne underkategorien?',
      'subcategory_deleted': 'Underkategori slettet',
      'delete_error': 'Feil ved sletting av underkategori',
    },
    'Bokvalitetsrosen': {
      'PlansPricing': {
        'title': 'Abonnement og priser',
        'description': 'Velg det abonnementet som passer best for din organisasjon. Medlemspris gjelder for medlemmer i Norsk Eiendom eller Arkitektbedriftene. Alle abonnement gir tilgang til de samme funksjonene.',
        'choose_button': 'Tegn abonnement',
        'subscription_terms_3': 'Alle abonnement gjelder for ett år og fornyes automatisk med mindre de sies opp. Oppsigelse må sendes skriftlig til',
        'subscription_terms_read_our_1': 'Les våre',
        'subscription_terms_read_our_2': 'kjøpsvilkår',
        'subscription_terms_read_our_3': 'for mer informasjon.',
        'subscription_terms_2': 'Betaling skjer via faktura. Ved behov for mer enn 5 brukere per organisasjon, tilkommer en ekstra kostnad.',
        'onlyInMunicipality': 'Kun ved bruk i kommunal sammenheng.',
        'plans_member_title': 'Medlem',
        'plans_member_price': '6 000 kr / år',
        'plans_member_description': 'For medlemmer av organisasjonen.',
        'plans_member_manchet': 'Kostnadsfritt ut 2025',
        'plans_member_features_feature_1': 'inntil 5 brukere per organisasjon',
        'plans_member_features_feature_2': 'personlig innlogging',
        'plans_member_features_feature_3': 'support via e-post',
        'plans_member_features_feature_4': 'kostnadsfritt ut 2025',
        'plans_member_features_feature_5': '',
        'plans_member_features_feature_6': 'Gratis testperiode hele 2026',
        'plans_non_member_title': 'Ikke-medlem',
        'plans_non_member_price': '10 000 kr / år',
        'plans_non_member_description': 'For ikke-medlemmer og eksterne organisasjoner.',
        'plans_non_member_manchet': 'Kostnadsfritt ut 2025',
        'plans_municipality_title': 'Kommune',
        'plans_municipality_price': '1 000 kr / år',
        'plans_municipality_description': 'Kun ved bruk i kommunal sammenheng.',
        'plans_municipality_manchet': 'Kostnadsfritt ut 2025',
      },
      'RequestLicenseModal': {
        'title': 'Tegn abonnement og få tilgang til Bokvalitetsrosen',
        'selected_plan': 'Valgt plan',
        'description': 'Fyll ut skjemaet nedenfor for å registrere din organisasjon. Når skjemaet er sendt inn, vil du motta en bekreftelse og få tildelt brukeradgang. Faktura sendes separat.',
        'confirm_button': 'Send inn skjema',
        'sections_organization_title': '1. Oplysninger om organisation',
        'sections_organization_company_name': 'Firmanavn / Kommunenavn',
        'sections_organization_organization_number': 'Organisationsnummer (valgfrit)',
        'sections_organization_company_type': 'Virksomhetstype',
        'sections_organization_company_type_placeholder': 'Velg type',
        'sections_organization_company_type_options_property': 'Ejendomsselskab',
        'sections_organization_company_type_options_architect': 'Arkitektfirma',
        'sections_organization_company_type_options_municipality': 'Kommune',
        'sections_organization_company_type_options_other': 'Andet',
        'sections_organization_other_company_type': 'Specificer anden type',
        'sections_organization_norsk_eiendom_member': 'Medlem av Norsk Eiendom eller Arkitektbedriftene?',
        'sections_organization_norsk_eiendom_yes': 'Ja',
        'sections_organization_norsk_eiendom_no': 'Nej',
        'sections_organization_company_size': 'Bedriftens størrelse (antall ansatte)',
        'sections_organization_company_size_placeholder': 'Velg størrelse',
        'sections_organization_company_size_options_1-5': '1–5',
        'sections_organization_company_size_options_6-20': '6–20',
        'sections_organization_company_size_options_21-50': '21–50',
        'sections_organization_company_size_options_51+': '51+',
        'sections_contact_title': '2. Personopplysninger',
        'sections_contact_description': 'Den første i din organisasjon som registrerer abonnementet blir administratorbruker. Dette kan endres senere',
        'sections_contact_name': 'Navn',
        'sections_contact_email': 'E-post',
        'sections_contact_phone': 'Telefonnummer',
        'sections_billing_title': '3. Faktureringsoplysninger',
        'sections_billing_contact': 'Fakturamodtager / kontaktperson',
        'sections_billing_address': 'Fakturaadresse',
        'sections_billing_ehf_id': 'Evt. EHF / elektronisk faktura-ID',
        'sections_billing_po_number': 'Evt. reference / PO-nummer',
        'sections_terms_title': '4. Vilkår og samtykke',
        'sections_terms_accept_terms': 'Jeg bekrefter og aksepterer',
        'sections_terms_terms_link': 'kjøpsvilkårene',
        'sections_terms_accept_billing': 'Jeg er innforstått med at abonnementet faktureres årlig, og gjelder til det blir sagt opp.',
        'validation_required_field': 'Feltet {field} er obligatorisk',
        'validation_specify_other_type': 'Vennligst spesifiser annen selskapstype',
        'validation_accept_terms_required': 'Du må godta vilkårene for å fortsette',
        'field_labels_companyName': 'Firmanavn / Kommunenavn',
        'field_labels_companyType': 'Type firma',
        'field_labels_norskEiendomMember': 'Medlem af Norsk Eiendom',
        'field_labels_companySize': 'Størrelsen på selskapet',
        'field_labels_contactName': 'Kontaktperson navn',
        'field_labels_contactEmail': 'E-mail',
        'field_labels_contactPhone': 'Telefonnummer',
        'field_labels_billingContact': 'Fakturamodtager',
        'field_labels_billingAddress': 'Fakturaadresse',
        'sub_text': 'Når du har sendt inn skjemaet, vil du innen få dager motta en bekreftelse og få tildelt brukeradgang.',
        'success_message': 'Forespørselen din er sendt! Du vil motta bekreftelse på e-post.',
      },
      'LicenseTerms': {
        'title': 'Kjøpsvilkår for Bokvalitetsrosen',
        'subtitle': 'Vedrørende tilgang og bruk av Bokvalitetsrosen – et dialogverktøy om bokvalitet i boligprosjekter, eid og forvaltet av Norsk Eiendom og Arkitektbedriftene.',
        'sections_introduction_title': 'Innledning',
        'sections_introduction_paragraph1': 'Ved opprettelse av brukertilgang til Bokvalitetsrosen inngås en juridisk bindende lisensavtale mellom Kunden og Norsk Eiendom (Org.nr: 884 097 932) og Arkitektbedriftene (Org nr 988 412 120) – heretter kalt "Eier".',
        'sections_introduction_paragraph2': 'Avtalen regulerer tilgang, bruk og rettigheter knyttet til verktøyet.',
        'sections_purpose_title': 'Formål',
        'sections_purpose_paragraph1': 'Bokvalitetsrosen er et digitalt dialogverktøy som støtter aktører i boligplanlegging og -utvikling i å definere, dokumentere og diskutere bokvalitet.',
        'sections_access_and_use_title': 'Tilgang og bruk',
        'sections_access_and_use_paragraph1': 'Tilgang til tjenesten forutsetter innlogging med personlig brukernavn og passord. Verktøyet tilbys i ulike abonnementstyper, og Eier forbeholder seg retten til å endre bruksvilkår, abonnementsvilkår og øvrige betingelser når som helst.',
        'sections_access_and_use_paragraph2': 'Tilgang gis til organisasjoner, med inntil 5 brukere inkludert per abonnement.',
        'sections_access_and_use_paragraph3': 'Kunden administrerer selv hvilke personer i organisasjonen som har tilgang, og kan endre dette over tid.',
        'sections_access_and_use_paragraph4': 'Tilgangen er personlig og skal ikke deles eller gjenbrukes av flere ansatte.',
        'sections_access_and_use_paragraph5': 'Ved behov for flere enn 5 brukere, påløper ekstra kostnad.',
        'sections_access_and_use_paragraph6': 'Alle brukere har tilgang til alle funksjoner, uavhengig av abonnementstype.',
        'sections_access_and_use_paragraph7': 'Registrering skjer via skjema på bokvalitetsrosen.no. Etter innsending mottar kunden bekreftelse og brukertilgang innen få virkedager (ordinære arbeidsdager utenom skoleferier). Den første som registrerer organisasjonen blir administrator, men dette kan endres senere.',
        'sections_access_and_use_paragraph8': 'Eier forbeholder seg retten til å årlig kunne slette inaktive brukere.',
        'sections_subscription_and_billing_title': 'Abonnement og fakturering',
        'sections_subscription_and_billing_paragraph1': 'Abonnementet gjelder for ett år og fornyes automatisk.',
        'sections_subscription_and_billing_paragraph2': 'Faktura sendes separat etter registrering.',
        'sections_subscription_and_billing_paragraph3': 'Avtalen gjelder til den blir sagt opp.',
        'sections_subscription_and_billing_paragraph4': 'Abonnementet er knyttet til organisasjonsnummer og kan ikke deles mellom ulike juridiske enheter. Kunden kan endre brukere internt i organisasjonen ved behov.',
        'sections_subscription_and_billing_paragraph5': 'Medlemspris gjelder for medlemmer i Norsk Eiendom eller Arkitektbedriftene. Ved innmelding i Norsk Eiendom eller Arkitektbedriftene samtidig som registrering i Bokvalitetsrosen, gis medlemspris.',
        'sections_support_and_maintenance_title': 'Support og vedlikehold',
        'sections_support_and_maintenance_paragraph1': 'Eier tilbyr brukerstøtte via e-post innen rimelig tid. Lenger ventetid må påregnes utenfor ordinær arbeidstid og i skolens ferier.',
        'sections_support_and_maintenance_paragraph2': 'Planlagt vedlikehold varsles minimum 48 timer i forkant. Eier er ikke ansvarlig for tap som følge av teknisk nedetid.',
        'sections_support_and_maintenance_paragraph3': 'Rådgivning utover vanlig brukerstøtte kan faktureres etter medgått tid.',
        'sections_support_and_maintenance_paragraph4': 'Alle henvendelser sendes til:',
        'sections_usage_rights_title': 'Bruksrett',
        'sections_usage_rights_paragraph1': 'Bokvalitetsrosen og alt tilhørende innhold eies av Eier. Kunden gis en begrenset bruksrett. Innholdet kan ikke benyttes til utvikling av kunstig intelligens eller maskinlæring uten særskilt tillatelse.',
        'sections_usage_rights_paragraph2': 'All bruk skal være i tråd med gjeldende opphavsrettslige regler.',
        'sections_privacy_title': 'Personvern',
        'sections_privacy_paragraph1': 'Personopplysninger behandles i henhold til GDPR og norsk lovgivning. Opplysninger brukes kun til administrasjon, support og forbedring av tjenesten.',
        'sections_privacy_paragraph2': 'Data deles ikke med tredjepart med mindre det er nødvendig for drift eller lovpålagt. Ved oppsigelse slettes personopplysninger innen 3 måneder, med mulighet for umiddelbar sletting.',
        'sections_privacy_paragraph3': 'Eier kan oppgi oversikt over registrerte brukere i en og samme organisasjon, til den som forespør dette internt.',
        'sections_breach_title': 'Mislighold',
        'sections_breach_paragraph1': 'Ved brudd på vilkårene kan tilgang stenges umiddelbart.',
        'sections_breach_paragraph2': 'Ved manglende betaling kan tilgang nektes eller avsluttes.',
        'sections_breach_paragraph3': 'Gjentatt mislighold kan føre til oppsigelse av avtalen.',
        'sections_liability_title': 'Ansvarsbegrensning',
        'sections_liability_paragraph1': 'Verktøyet er et dialogverktøy og gir ingen garanti for prosjektgodkjenning, økonomisk gevinst eller annen effekt.',
        'sections_liability_paragraph2': 'Eier fraskriver seg ansvar for tap, skader eller kostnader som følge av bruk.',
        'sections_liability_paragraph3': 'Eventuelle erstatningskrav er begrenset til NOK 10 000.',
        'sections_termination_title': 'Ikrafttredelse og oppsigelse',
        'sections_termination_paragraph1': 'Avtalen trer i kraft ved innsending av registreringsskjema, og gjelder til den blir sagt opp.',
        'sections_termination_paragraph2': 'Avtalen kan sies opp med én måneds varsel.',
        'sections_termination_paragraph3': 'Betalt faktura refunderes ikke.',
        'sections_termination_paragraph4': 'Ved oppsigelse slettes kundedata innen 12 måneder, med mulighet for umiddelbar sletting.',
        'sections_disputes_title': 'Tvister',
        'sections_disputes_paragraph1': 'Avtalen er underlagt norsk rett.',
        'sections_disputes_paragraph2': 'Oslo tingrett er verneting ved eventuelle tvister.',
        'sections_date': 'Oslo, 09.09.2025',
        'sections_trial_title': 'Prøvetid som testbruker',
        'sections_trial_paragraph1': 'Organisasjoner kan etter avtale få 1 måneds prøvetid som testbruker. Tilgangen gir samme funksjonalitet som ved ordinært abonnement. Testperioden starter på bekreftet oppstartsdato og utløper automatisk etter én måned. Abonnementet aktiveres først når prøveperioden er avsluttet.',
        'sections_trial_paragraph2': 'Dersom det er ønskelig å fortsette etter prøveperioden, løper abonnementet for ett år i henhold til gjeldende priser og vilkår.',
      },
      'license_requests': {
        'License Request': 'Lisensforespørsel',
        'No license requests found.': 'Ingen lisensforespørsler funnet.',
        'Convert License Request': 'Konverter Lisensforespørsel',
        'License Requests': 'Lisensforespørsler',
        'Failed to load license requests': 'Kunne ikke laste lisensforespørsler',
        'Admin Notes': 'Administratørnotater',
        'Saving...': 'Lagrer...',
        'Save Notes': 'Lagre Notater',
        'Close': 'Lukk',
        'Convert to Organization': 'Konverter til Organisasjon',
        'Are you sure you want to delete the request? This action cannot be undone.': 'Er du sikker på at du vil slette forespørselen? Denne handlingen kan ikke angres.',
        'Company': 'Firma',
        'Contact': 'Kontakt',
        'Email': 'E-post',
        'Plan': 'Plan',
        'Status': 'Status',
        'Submitted': 'Innsendt',
        'Name': 'Navn',
        'Address': 'Adresse',
        'Role': 'Rolle',
        'Cancel': 'Avbryt',
        'Convert': 'Konverter',
        'Search requests': 'Søk forespørsler...',
        'Organization to be created': 'Organisasjon som skal opprettes',
        'Delete': 'Slett',
        'An invitation email will be sent automatically to the user': 'En invitasjons-e-post vil bli sendt automatisk til brukeren.',
        'This will create a new organization and user account based on the request': 'Dette vil opprette en ny organisasjon og brukerprofil basert på forespørselen',
      },
    },
  },
}

export default messages
